import React, { useState, useRef, Component } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeftIcon, AlertTriangle, Eye, Search, Heart, MessageCircle, UserPlus, ThumbsDown, Target, Camera, Zap, TrendingUp, AlarmClockOff, RefreshCw, XCircle, Sparkles, Clock, MessageSquare, Repeat, BookOpen, ChevronRight, Wand2, Smartphone, Share2, Flame, Lightbulb, Tags, Monitor, Plus, Equal, Anchor, HeartHandshake, AlertCircle, HelpCircle, Gamepad2, Fingerprint, Quote, ArrowRight, PawPrint, Bird, Copy, FileText, Megaphone, Film, Smile, Link2, Ban, CheckCircle2, Rocket, Download, Apple, PlayCircle, Compass, Crown, UserCircle2 } from 'lucide-react';
import { motion } from 'framer-motion';
const topics = [{
  id: 'getting-started',
  name: 'Getting Started',
  description: 'Set up Pawchi and your Pawchi Plus access'
}, {
  id: 'account-warmup',
  name: 'Account Warmup',
  description: 'How to set up your TikTok account for success'
}, {
  id: 'viral-formula',
  name: 'The Viral Formula',
  description: 'The 4 organic formats that drive Pawchi growth'
}, {
  id: 'hooks',
  name: 'Hooks & Viral Angles',
  description: 'High-leverage hook patterns + comment bait'
}, {
  id: 'finch-pawchi',
  name: 'Finch → Pawchi Examples',
  description: 'Proven Finch UGC captions, remixed for Pawchi'
}, {
  id: 'ugc-brief',
  name: 'UGC Brief',
  description: 'The complete creative brief template for Pawchi videos'
}];
export function CreatorHelpCenter() {
  const [activeTopic, setActiveTopic] = useState('getting-started');
  const mainRef = useRef<HTMLElement>(null);
  function handleTopicSelect(topicId: string) {
    setActiveTopic(topicId);
    requestAnimationFrame(() => {
      mainRef.current?.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    });
  }
  return <div className="min-h-screen bg-cream" data-id="element-189" data-mp="d8v5tl2668rv">
      <div className="max-w-7xl mx-auto px-6 pt-32 pb-20" data-id="element-190" data-mp="n3aiifqls207">
        <Link to="/creator" className="inline-flex items-center gap-2 text-warmBrown/60 hover:text-peach transition-colors mb-8 font-medium" data-id="element-191" data-mp="n0o7g64i74d8">
          <ArrowLeftIcon size={18} data-id="element-192" data-mp="e0how5ty7e77" />
          Back to Creator Program
        </Link>

        <div className="mb-12 max-w-2xl" data-id="element-193" data-mp="92g9buvqdx0h">
          <div className="inline-flex items-center gap-2 bg-peach/10 text-peach px-3 py-1 rounded-full text-sm font-bold mb-4" data-id="element-194" data-mp="444vl92bf2cz">
            <BookOpen size={14} data-id="element-195" data-mp="3viked63wgazj" />
            Creator Help Center
          </div>
          <h1 className="text-4xl md:text-5xl font-black text-warmBrown mb-4 leading-tight" data-id="element-196" data-mp="3rgz5dvuhkgum">
            Everything you need to{' '}
            <span className="text-peach" data-id="element-197" data-mp="3mj778k38zyhz">create content that converts</span>
          </h1>
          <p className="text-warmBrown/80 text-lg leading-relaxed" data-id="element-198" data-mp="3hhzvk9xzif61">
            Guides, protocols, and tips to help you grow your audience and earn
            more with Pawchi.
          </p>
        </div>

        <div className="grid md:grid-cols-[260px_1fr] gap-10" data-id="element-199" data-mp="32ezw3mtdvyd1">
          {/* Sidebar */}
          <aside data-id="element-200" data-mp="37ebaip6a2rrg">
            <div className="sticky top-32" data-id="element-201" data-mp="37dtbjks8dzfu">
              <h4 className="text-xs font-bold uppercase tracking-wider text-warmBrown/40 mb-4" data-id="element-202" data-mp="3ce7guv2g6va6">
                Topics
              </h4>
              <nav className="space-y-1" data-id="element-203" data-mp="3hc929mncj6ot">
                {topics.map(topic => <button key={topic.id} onClick={() => handleTopicSelect(topic.id)} className={`w-full text-left px-4 py-3 rounded-xl flex items-center justify-between transition-all ${activeTopic === topic.id ? 'bg-peach text-white shadow-soft' : 'text-warmBrown hover:bg-white'}`} data-id="element-204" data-mp="2jqbbl1ytbv1s">
                    <span className="font-medium" data-id="element-205" data-mp="2yg98c6at5t2l">{topic.name}</span>
                    <ChevronRight size={16} className={activeTopic === topic.id ? 'opacity-100' : 'opacity-30'} data-id="element-206" data-mp="20yit41hdds8b" />
                  </button>)}

                <div className="mt-6 p-4 bg-white rounded-xl border border-warmBrown/5" data-id="element-207" data-mp="6jlj93gvagwo">
                  <p className="text-xs text-warmBrown/60 leading-relaxed" data-id="element-208" data-mp="l7zt3ycpb5mq">
                    More guides coming soon. Have a topic you want covered?{' '}
                    <Link to="/contact-us" className="text-peach font-bold hover:underline" data-id="element-209" data-mp="gex0bsfr007l">
                      Let us know
                    </Link>
                    .
                  </p>
                </div>
              </nav>
            </div>
          </aside>

          {/* Main content */}
          <main ref={mainRef} className="scroll-mt-32" data-id="element-210" data-mp="z8sn8hz3bypb">
            {activeTopic === 'getting-started' && <GettingStartedTopic data-id="element-211" data-mp="35yqk6j65pjyq" />}
            {activeTopic === 'account-warmup' && <AccountWarmupTopic data-id="element-212" data-mp="30ze0266o6qzu" />}
            {activeTopic === 'viral-formula' && <ViralFormulaTopic data-id="element-213" data-mp="1ggtn0ex0e9n6" />}
            {activeTopic === 'hooks' && <HooksTopic data-id="element-214" data-mp="1ghbte4ddy48t" />}
            {activeTopic === 'finch-pawchi' && <FinchPawchiTopic data-id="element-215" data-mp="1lgfzgm50jlux" />}
            {activeTopic === 'ugc-brief' && <UgcBriefTopic data-id="element-216" data-mp="1lhr4epa72znm" />}
          </main>
        </div>
      </div>
    </div>;
}
function GettingStartedTopic() {
  const steps = [{
    number: 1,
    title: 'Download Pawchi',
    icon: <Download size={22} data-id="element-217" data-mp="1bnqpxwt0wi28" />,
    color: 'peach' as const,
    content: <>
          <p className="text-warmBrown/80 leading-relaxed mb-5" data-id="element-218" data-mp="xsez40hznbql">
            Pawchi is available on iOS and Android. Tap the matching badge for
            your phone to install.
          </p>
          <div className="flex flex-col sm:flex-row gap-3" data-id="element-219" data-mp="ntz7lwf1u0gk">
            <motion.a href="https://apps.apple.com/us/app/pawchi-self-care-pet/id6764858701" target="_blank" rel="noopener noreferrer" whileHover={{
          scale: 1.03
        }} whileTap={{
          scale: 0.97
        }} className="inline-block" data-id="element-220" data-mp="ssaebya1ruuk">
              <img src="https://cdn.magicpatterns.com/uploads/bgW7hVXTEHmConMeGXzro4/app-store.svg" alt="Download on the App Store" className="h-[52px] w-auto" data-id="element-221" data-mp="2gp9wvcoj5804" />
            </motion.a>
            <motion.a href="https://play.google.com/store/apps/details?id=app.pawchi.mobile" target="_blank" rel="noopener noreferrer" whileHover={{
          scale: 1.03
        }} whileTap={{
          scale: 0.97
        }} className="inline-block -ml-3 sm:ml-0" data-id="element-222" data-mp="27pwji8xabza4">
              <img src="https://cdn.magicpatterns.com/uploads/omQrJZxYBdQEgWZzBHqrye/play-store.png" alt="Get it on Google Play" className="h-[76px] w-auto -my-3" data-id="element-223" data-mp="2qmefx3n2wncp" />
            </motion.a>
          </div>
        </>
  }, {
    number: 2,
    title: 'Create your Pawchi',
    icon: <PawPrint size={22} data-id="element-224" data-mp="19uj30yxgn7ad" />,
    color: 'coral' as const,
    content: <>
          <p className="text-warmBrown/80 leading-relaxed mb-4" data-id="element-225" data-mp="1dwe3y2bhbinm">
            Upload a photo of your pet to transform them into your digital
            Pawchi companion. Pick a clear, well-lit shot for the best
            transformation.
          </p>
          <Callout color="peach" icon={<HeartHandshake size={16} data-id="element-227" data-mp="1stewg81hvhn5" />} title="Don't have a pet?" data-id="element-226" data-mp="1ntsfpomgjj9l">
            No problem! Use any pet photo you love, or{' '}
            <strong data-id="element-228" data-mp="1xkwykzf97o9p">contact us</strong> and we'll assign one for you.
          </Callout>
          <Callout color="lavender" icon={<Sparkles size={16} data-id="element-230" data-mp="26l33vy0sthxs" />} title="Pro tip: make it unique" data-id="element-229" data-mp="21koxslirci2e">
            Add a <strong data-id="element-231" data-mp="2bk63h2y0evyd">funny feature or accessory</strong> to your Pawchi —
            sunglasses, a tiny hat, a chef's apron, anything weird. A
            one-of-a-kind look is what makes viewers stop scrolling and comment.
          </Callout>
        </>
  }, {
    number: 3,
    title: 'Complete onboarding',
    icon: <CheckCircle2 size={22} data-id="element-232" data-mp="1vhysqiexmrna" />,
    color: 'lavender' as const,
    content: <>
          <p className="text-warmBrown/80 leading-relaxed mb-4" data-id="element-233" data-mp="1rfu1fqbyi73t">
            Walk through the onboarding flow inside the app. This sets up your
            habits, mood tracker, and connects everything to your new Pawchi.
          </p>
          <Callout color="coral" icon={<Film size={16} data-id="element-235" data-mp="1cjcqv1blcwib" />} title="Hit record before you start" data-id="element-234" data-mp="yt9c0vf1k52w">
            Screen-record your onboarding so you can{' '}
            <strong data-id="element-236" data-mp="17qtdo5gtg3e1">capture the emotional transformation</strong> from your real
            pet to the digitized Pawchi. That reveal moment is your most viral
            asset — you only get one first reaction, so don't miss it.
          </Callout>
        </>
  }, {
    number: 4,
    title: 'Explore the app',
    icon: <Compass size={22} data-id="element-237" data-mp="angk41piv6ih" />,
    color: 'sage' as const,
    content: <p className="text-warmBrown/80 leading-relaxed" data-id="element-238" data-mp="apjjhcckebzv">
          Tap around. Get comfortable with how habits, the mood log, breathing
          exercises, and your Pawchi's reactions all fit together. The more
          familiar you are, the more genuine your videos will feel.
        </p>
  }, {
    number: 5,
    title: 'Unlock Pawchi Plus',
    icon: <Crown size={22} data-id="element-239" data-mp="tm2l7gl1gxme" />,
    color: 'peach' as const,
    content: <>
          <p className="text-warmBrown/80 leading-relaxed mb-4" data-id="element-240" data-mp="eoijcijfvikg">
            Once you've explored the app,{' '}
            <strong className="text-warmBrown" data-id="element-241" data-mp="jmtuqxpdu14s">let us know</strong> — we'll
            grant you Pawchi Plus, which unlocks all animations and premium
            features so your content can showcase the full experience.
          </p>
          <Callout color="lavender" icon={<Sparkles size={16} data-id="element-243" data-mp="1ijm30kyxcdj8" />} title="Need more Pawchis?" data-id="element-242" data-mp="1iiawide3grof">
            If you want to feature additional pets in your content, contact us
            for <strong data-id="element-244" data-mp="18t122qvs2wx5">extra credits</strong>.
          </Callout>
        </>
  }];
  const colorMap = {
    peach: {
      bg: 'bg-peach/10',
      text: 'text-peach',
      solid: 'bg-peach'
    },
    coral: {
      bg: 'bg-coral/10',
      text: 'text-coral',
      solid: 'bg-coral'
    },
    lavender: {
      bg: 'bg-lavender/10',
      text: 'text-lavender',
      solid: 'bg-lavender'
    },
    sage: {
      bg: 'bg-sage/10',
      text: 'text-sage',
      solid: 'bg-sage'
    }
  };
  return <motion.article initial={{
    opacity: 0,
    y: 20
  }} animate={{
    opacity: 1,
    y: 0
  }} transition={{
    duration: 0.4
  }} className="space-y-10" data-id="element-245" data-mp="utrntwr4ucvt">
      {/* Intro */}
      <header data-id="element-246" data-mp="2p4dgk4azl16m">
        <div className="inline-flex items-center gap-2 bg-sage/10 text-sage px-3 py-1.5 rounded-full text-xs font-bold uppercase tracking-wider mb-4" data-id="element-247" data-mp="dj4kscdcw8lj">
          <Rocket size={14} data-id="element-248" data-mp="8lw1u9kdw0j8" />
          Start Here
        </div>
        <h2 className="text-3xl md:text-4xl font-black text-warmBrown mb-4" data-id="element-249" data-mp="n9h3dz1m1rp1">
          Getting Started with Pawchi
        </h2>
        <p className="text-warmBrown/80 text-lg leading-relaxed" data-id="element-250" data-mp="igwbx466fqoo">
          Welcome to the Pawchi Creator Program! Follow these{' '}
          <strong className="text-warmBrown" data-id="element-251" data-mp="wbqeor4pdp3h">5 quick steps</strong> to get set
          up with the app, unlock Pawchi Plus, and start creating content.
        </p>
      </header>

      {/* What is Pawchi */}
      <section className="bg-gradient-to-br from-peach to-coral rounded-3xl p-8 md:p-10 text-white" data-id="element-252" data-mp="118yvana7dl2m">
        <div className="inline-flex items-center gap-2 bg-white/20 backdrop-blur-sm px-3 py-1.5 rounded-full text-xs font-bold uppercase tracking-wider mb-4" data-id="element-253" data-mp="37zewa7a6aoui">
          <PawPrint size={14} data-id="element-254" data-mp="331wlscgic1ke" />
          What is Pawchi?
        </div>
        <p className="text-xl md:text-2xl font-bold leading-snug mb-3" data-id="element-255" data-mp="16y8ls6pn0990">
          Pawchi turns your real pet into a cute digital companion.
        </p>
        <p className="text-white/90 leading-relaxed" data-id="element-256" data-mp="1by4q6728y2p3">
          Keep them happy by completing daily habits, tracking your mood, and
          taking moments to breathe. Self-care, gamified — and powered by the
          pet you actually love.
        </p>
      </section>

      {/* Steps */}
      <section className="space-y-5" data-id="element-257" data-mp="1ptyo5v1hf7nf">
        {steps.map(step => {
        const c = colorMap[step.color];
        return <article key={step.number} className="bg-white rounded-3xl p-8 shadow-soft border border-warmBrown/5" data-id="element-258" data-mp="1zlcizpihnja8">
              <div className="flex items-start gap-4 mb-5" data-id="element-259" data-mp="23mof8dvvb2re">
                <div className={`w-14 h-14 rounded-2xl ${c.solid} text-white flex items-center justify-center flex-shrink-0 font-black text-xl`} data-id="element-260" data-mp="28nlsqd5xn8mk">
                  {step.number}
                </div>
                <div className="flex-1 min-w-0" data-id="element-261" data-mp="2nqvn92afqms4">
                  <div className="flex items-center gap-2 mb-1" data-id="element-262" data-mp="2ipy5gqtc7ur5">
                    <span className={c.text} data-id="element-263" data-mp="2isu2mcxd2fej">{step.icon}</span>
                    <p className={`text-xs font-bold uppercase tracking-wider ${c.text}`} data-id="element-264" data-mp="2ds65ramgb4ce">
                      Step {step.number}
                    </p>
                  </div>
                  <h3 className="text-2xl font-black text-warmBrown" data-id="element-265" data-mp="36i6a98d1ifeq">
                    {step.title}
                  </h3>
                </div>
              </div>
              <div data-id="element-266" data-mp="2wp7cp0zkfeiz">{step.content}</div>
            </article>;
      })}
      </section>

      {/* Contact us */}
      <section className="bg-warmBrown rounded-3xl p-8 md:p-10 text-cream" data-id="element-267" data-mp="2soezjwnkophf">
        <div className="flex items-start gap-4 mb-4" data-id="element-268" data-mp="3p7l7sstiomed">
          <div className="w-12 h-12 rounded-full bg-peach/20 text-peach flex items-center justify-center flex-shrink-0" data-id="element-269" data-mp="3kfuxgmukxymy">
            <UserCircle2 size={22} data-id="element-270" data-mp="34xacpy90qinl" />
          </div>
          <div data-id="element-271" data-mp="34zwjvwrzyw5a">
            <h3 className="text-2xl font-black mb-1" data-id="element-272" data-mp="35068bfxe8v8v">Need help? Contact us</h3>
            <p className="text-cream/60 text-sm" data-id="element-273" data-mp="39y7qlymzwqja">
              For Pawchi Plus access, extra credits, or anything you get stuck
              on.
            </p>
          </div>
        </div>
        <Link to="/contact-us" className="inline-flex items-center gap-2 px-6 py-3 bg-peach hover:bg-peach/90 text-white rounded-full font-bold transition-colors mt-4" data-id="element-274" data-mp="2zz0h5mjdtg1g">
          Get in touch
          <ArrowRight size={16} data-id="element-275" data-mp="3sp8ris7oew5h" />
        </Link>
      </section>

      {/* Copyright rules */}
      <section className="bg-white rounded-3xl p-8 md:p-10 shadow-soft border border-coral/20" data-id="element-276" data-mp="3etwtoby84pkc">
        <div className="flex items-start gap-4 mb-5" data-id="element-277" data-mp="3ivi47qnacrrd">
          <div className="w-12 h-12 rounded-full bg-coral/10 text-coral flex items-center justify-center flex-shrink-0" data-id="element-278" data-mp="agqbmgv2jx9g">
            <Ban size={22} data-id="element-279" data-mp="fa2ltlz041io" />
          </div>
          <div data-id="element-280" data-mp="1zyn80iwe73jy">
            <p className="text-xs font-bold uppercase tracking-wider text-coral mb-1" data-id="element-281" data-mp="1zyexgxnqsabx">
              Non-Negotiable
            </p>
            <h3 className="text-2xl font-black text-warmBrown" data-id="element-282" data-mp="1uzamq2l664jh">
              No Copyrighted or Trademarked Plushies
            </h3>
            <p className="text-warmBrown/60 text-sm mt-1" data-id="element-283" data-mp="29qkjzrv85zjq">
              Applies to your Pawchi and to anything visible on camera.
            </p>
          </div>
        </div>

        <p className="text-warmBrown/80 leading-relaxed mb-5" data-id="element-284" data-mp="1h0ayux5hdtod">
          Licensed characters and branded plushies are protected trademarks. Do
          not turn them into a Pawchi, and do not feature them in your content —
          it exposes both you and Pawchi to takedowns and legal risk.
        </p>

        <p className="text-xs font-bold uppercase tracking-wider text-warmBrown/40 mb-2" data-id="element-285" data-mp="1m18ep330qbmp">
          Do not use
        </p>
        <div className="flex flex-wrap gap-2 mb-5" data-id="element-286" data-mp="2xeatptpgyt4r">
          {['Disney characters', 'Jellycat', 'Squishmallows', 'Sanrio / Hello Kitty', 'Pokémon', 'Build-A-Bear licensed lines', 'Any branded or licensed character plush'].map(brand => <span key={brand} className="px-3 py-1.5 bg-coral/10 text-coral rounded-lg font-bold text-sm border border-coral/20" data-id="element-287" data-mp="3egq4x7zrchxw">
              {brand}
            </span>)}
        </div>

        <Callout color="sage" icon={<CheckCircle2 size={16} data-id="element-289" data-mp="2qpayp44v1ghd" />} title="Use this instead" data-id="element-288" data-mp="2lowphiriw0hr">
          Your <strong data-id="element-290" data-mp="2vonjljc68dhb">real pet</strong>, a{' '}
          <strong data-id="element-291" data-mp="2vnm9bh2zbv0n">generic, unbranded plushie or stuffed animal</strong>, or a
          non-licensed figure. Unbranded companions work better anyway — the
          story is your bond with them, not the brand on the tag.
        </Callout>
      </section>

      {/* Next steps */}
      <Callout color="sage" icon={<Lightbulb size={18} data-id="element-293" data-mp="27xi79e5fw3br" />} title="Once you're set up" data-id="element-292" data-mp="27ykvfebdnrnz">
        Jump to <strong data-id="element-294" data-mp="p3p0q56gefl0">Account Warmup</strong> next to prep your TikTok or
        Instagram account before posting your first Pawchi video. The warmup is
        the #1 reason new creators see early traction.
      </Callout>
    </motion.article>;
}
function AccountWarmupTopic() {
  return <motion.article initial={{
    opacity: 0,
    y: 20
  }} animate={{
    opacity: 1,
    y: 0
  }} transition={{
    duration: 0.4
  }} className="space-y-10" data-id="element-295" data-mp="b3xittctgf1q">
      {/* Intro */}
      <header data-id="element-296" data-mp="3tipyn060w9t4">
        <div className="inline-flex items-center gap-2 bg-coral/10 text-coral px-3 py-1.5 rounded-full text-xs font-bold uppercase tracking-wider mb-4" data-id="element-297" data-mp="3ti6q2a29ixrr">
          <AlertTriangle size={14} data-id="element-298" data-mp="3ohio4tchwwir" />
          Non-Negotiable
        </div>
        <h2 className="text-3xl md:text-4xl font-black text-warmBrown mb-4" data-id="element-299" data-mp="3jj7gmp9oay3p">
          Account Warmup Protocol
        </h2>
        <p className="text-warmBrown/80 text-lg leading-relaxed" data-id="element-300" data-mp="3enimj1gfa9es">
          Starting a new account without warmup is the{' '}
          <strong className="text-warmBrown" data-id="element-301" data-mp="1bbkfdze5s9h8">
            #1 reason first videos flop
          </strong>
          . TikTok needs behavioral signal before it knows who to show your
          content to.
        </p>
      </header>

      {/* Step 0: Handle Setup */}
      <section className="bg-white rounded-3xl p-8 md:p-10 shadow-soft border border-warmBrown/5" data-id="element-302" data-mp="129b7lha9yu7j">
        <div className="flex items-start gap-4 mb-5" data-id="element-303" data-mp="nkyk78p96jon">
          <div className="w-14 h-14 rounded-2xl bg-warmBrown text-cream flex items-center justify-center flex-shrink-0 font-black text-xl" data-id="element-304" data-mp="sd84a83ospj0">
            0
          </div>
          <div className="flex-1 min-w-0" data-id="element-305" data-mp="jko2iys3m4ty">
            <p className="text-xs font-bold uppercase tracking-wider text-warmBrown/40 mb-1" data-id="element-306" data-mp="jlpnbuyx25ov">
              Before You Begin
            </p>
            <h3 className="text-2xl font-black text-warmBrown" data-id="element-307" data-mp="4pq8m1hax7ar">
              Set Up Your Handles
            </h3>
            <p className="text-warmBrown/60 text-sm mt-1" data-id="element-308" data-mp="3m62z78lue0t9">
              Lock in your TikTok and Instagram handles before posting day 1.
            </p>
          </div>
        </div>

        <div className="space-y-5" data-id="element-309" data-mp="3i6k9lzj2t1k3">
          <div data-id="element-310" data-mp="3w4s666c7a0uq">
            <p className="text-xs font-bold uppercase tracking-wider text-peach mb-2" data-id="element-311" data-mp="3w5a7hhdpz59i">
              Step 1 · Pick a handle
            </p>
            <p className="text-warmBrown/80 leading-relaxed mb-3" data-id="element-312" data-mp="3r78rx6fi5o2s">
              Choose the same handle for TikTok and Instagram. We recommend{' '}
              <strong className="text-warmBrown" data-id="element-313" data-mp="4yr0kdb07zgh">your name + pet name</strong>{' '}
              or something{' '}
              <strong className="text-warmBrown" data-id="element-314" data-mp="io17hewuzvc6">
                wellness / self-care related
              </strong>
              .
            </p>

            <p className="text-xs font-bold uppercase tracking-wider text-warmBrown/40 mb-2" data-id="element-315" data-mp="snjp3opar512">
              Examples
            </p>
            <div className="flex flex-wrap gap-2" data-id="element-316" data-mp="np8gtienh2ky">
              {['@miguelandpolo', '@dailypolo', '@dailylifeofatlas', '@atlasselfcare'].map(handle => <span key={handle} className="px-3 py-1.5 bg-peach/10 text-peach rounded-lg font-bold text-sm border border-peach/20" data-id="element-317" data-mp="v7u7ihcx4emb">
                  {handle}
                </span>)}
            </div>
          </div>

          <div data-id="element-318" data-mp="hh796qb2kqqr">
            <p className="text-xs font-bold uppercase tracking-wider text-peach mb-2" data-id="element-319" data-mp="hel6b3z4izev">
              Step 2 · Send us your info
            </p>
            <p className="text-warmBrown/80 leading-relaxed mb-3" data-id="element-320" data-mp="q9ixa5ipo23k">
              Once you've picked your handle, send us:
            </p>
            <ul className="space-y-2" data-id="element-321" data-mp="lgpsxir5mvs0">
              <li className="flex items-start gap-3 text-warmBrown/80" data-id="element-322" data-mp="3ty2qhqeyumbw">
                <CheckCircle2 size={18} className="text-peach mt-0.5 flex-shrink-0" data-id="element-323" data-mp="3tvzu8on7zwyq" />
                Your{' '}
                <strong className="text-warmBrown" data-id="element-324" data-mp="3friys7awnyma">
                  chosen TikTok & Instagram handle
                </strong>
              </li>
              <li className="flex items-start gap-3 text-warmBrown/80" data-id="element-325" data-mp="3kl3svo9do8g7">
                <CheckCircle2 size={18} className="text-peach mt-0.5 flex-shrink-0" data-id="element-326" data-mp="35vxrbtn2i655" />
                Your{' '}
                <strong className="text-warmBrown" data-id="element-327" data-mp="2decptxbayst">
                  personal email address
                </strong>
              </li>
            </ul>
          </div>

          <div data-id="element-328" data-mp="3okw468q5osp9">
            <p className="text-xs font-bold uppercase tracking-wider text-peach mb-2" data-id="element-329" data-mp="3oldw4t5sckrd">
              Step 3 · Get your creator email
            </p>
            <p className="text-warmBrown/80 leading-relaxed" data-id="element-330" data-mp="3ti4b1d5utab7">
              We'll send you back a{' '}
              <strong className="text-warmBrown" data-id="element-331" data-mp="2d4e5s3300fzz">
                dedicated email address
              </strong>{' '}
              to use when signing up on TikTok and Instagram. This keeps your
              creator accounts clean and separate from your personal inbox.
            </p>
          </div>

          <div data-id="element-332" data-mp="jp32wh5dpg16">
            <p className="text-xs font-bold uppercase tracking-wider text-peach mb-2" data-id="element-333" data-mp="jpcl3ik6miwb">
              Step 4 · Sign up and set up your accounts
            </p>
            <p className="text-warmBrown/80 leading-relaxed mb-3" data-id="element-334" data-mp="9wdq9iy3dw49">
              Use the{' '}
              <strong className="text-warmBrown" data-id="element-335" data-mp="4yvg5p8c9auo">dedicated email</strong> we
              sent you to create your TikTok and Instagram accounts under your
              chosen handle. Then fill out the profile:
            </p>
            <ul className="space-y-2 mb-4" data-id="element-336" data-mp="3s4w6xwiiwz1c">
              <li className="flex items-start gap-3 text-warmBrown/80" data-id="element-337" data-mp="3n48gbby7ik7n">
                <CheckCircle2 size={18} className="text-peach mt-0.5 flex-shrink-0" data-id="element-338" data-mp="1qbf210ls2caa" />
                Use a{' '}
                <strong className="text-warmBrown" data-id="element-339" data-mp="1lcveivrjcsft">
                  genuine, authentic photo of you and your pet
                </strong>{' '}
                as your profile picture
              </li>
              <li className="flex items-start gap-3 text-warmBrown/80" data-id="element-340" data-mp="1xt4vj4cji1y3">
                <CheckCircle2 size={18} className="text-peach mt-0.5 flex-shrink-0" data-id="element-341" data-mp="22mpm4bbsztn9" />
                Write a short, friendly bio that hints at the self-care + pet
                vibe
              </li>
              <li className="flex items-start gap-3 text-warmBrown/80" data-id="element-342" data-mp="1ew3ntbrlpnqg">
                <CheckCircle2 size={18} className="text-peach mt-0.5 flex-shrink-0" data-id="element-343" data-mp="1ewc0p3nq4t1n" />
                Keep the same handle, photo, and bio consistent across TikTok
                and Instagram
              </li>
            </ul>
            <Callout color="sage" icon={<Heart size={16} data-id="element-345" data-mp="3096er39ldj2o" />} title="Why authentic matters" data-id="element-344" data-mp="2v9k32y9ewavz">
              Real-you-with-real-pet photos build trust instantly. Stock images,
              AI portraits, or pet-only photos look like a brand account — which
              kills the personal-discovery feel that drives conversions.
            </Callout>
          </div>

          <Link to="/contact-us" className="inline-flex items-center gap-2 px-6 py-3 bg-peach hover:bg-peach/90 text-white rounded-full font-bold transition-colors" data-id="element-346" data-mp="37u8z2nzquo5j">
            Send your handle
            <ArrowRight size={16} data-id="element-347" data-mp="3cs0s5lc4kgbb" />
          </Link>
        </div>
      </section>

      {/* Days 1-2 */}
      <PhaseCard phase="Days 1–2" title="Pure Observer Mode" color="lavender" icon={<Eye size={24} data-id="element-349" data-mp="3ljua9c7axz30" />} data-id="element-348" data-mp="3qj5rembkz6l4">
        <div className="space-y-4" data-id="element-350" data-mp="3llnk10d7ozf8">
          <Rule icon={<XCircle size={18} data-id="element-352" data-mp="4c8od12t04o8" />} negative data-id="element-351" data-mp="3lmov34u89lwy">
            Do <strong data-id="element-353" data-mp="4d0jkasho0dz">NOT</strong> post anything
          </Rule>
          <Rule icon={<Clock size={18} data-id="element-355" data-mp="3vjbdlmz300vt" />} data-id="element-354" data-mp="3vj1xqs7r3a3u">
            Open app <strong data-id="element-356" data-mp="3vkcz6ldq45rs">2× per day</strong>, 10 minutes each session
          </Rule>
          <Rule icon={<Search size={18} data-id="element-358" data-mp="izfrikm1ryck" />} data-id="element-357" data-mp="j08y9ll0anup">
            Search your exact niche:{' '}
            <em className="text-warmBrown/70" data-id="element-359" data-mp="mzht6trs8rru">
              "pet care routine," "self-care habits," "tamagotchi," "virtual
              pet," "cat routine," "dog self care"
            </em>
          </Rule>
          <Rule icon={<Eye size={18} data-id="element-361" data-mp="dy9uwbp9nqxr" />} data-id="element-360" data-mp="dyjk3x2hlu2e">
            Watch every video <strong data-id="element-362" data-mp="3vgkxn4z95v1t">TO THE END</strong> — partial watches are
            negative signals
          </Rule>
          <Rule icon={<Heart size={18} data-id="element-364" data-mp="41x0tcpt7b2h" />} data-id="element-363" data-mp="426tx965hyce">
            Like <strong data-id="element-365" data-mp="42yfdr61afoy">20–30 niche videos</strong> per day
          </Rule>
          <Rule icon={<MessageCircle size={18} data-id="element-367" data-mp="3mgxykptzx1bx" />} data-id="element-366" data-mp="3mgph0kmxh7ue">
            Leave <strong data-id="element-368" data-mp="3rer2fc7ttj91">5 genuine comments</strong> (full sentences, not
            emojis or one-word replies)
          </Rule>
          <Rule icon={<UserPlus size={18} data-id="element-370" data-mp="3cii2s9k0x3w3" />} data-id="element-369" data-mp="3ch6zeauhpy5i">
            Follow <strong data-id="element-371" data-mp="3cjjpjbaejetn">3–5 relevant accounts</strong>
          </Rule>
          <Rule icon={<ThumbsDown size={18} data-id="element-373" data-mp="3hg1v2ddk3h71" />} data-id="element-372" data-mp="3hf8jmz3nk3ik">
            Aggressively tap <strong data-id="element-374" data-mp="2ycgh2esfg8rl">"Not Interested"</strong> on anything
            off-niche
          </Rule>
        </div>

        <Callout color="sage" icon={<Target size={18} data-id="element-376" data-mp="2tjnbjop4wweg" />} title="Goal by Day 2" data-id="element-375" data-mp="2tkye5l6ufy3z">
          Your For You Page shows pet content, self-care content, habit apps,
          and cute animal transformations. If it doesn't,{' '}
          <strong data-id="element-377" data-mp="2jod6st7cqawz">you moved too fast</strong>.
        </Callout>
      </PhaseCard>

      {/* Engagement Mix */}
      <section className="bg-white rounded-3xl p-8 md:p-10 shadow-soft border border-warmBrown/5" data-id="element-378" data-mp="3haancl26866a">
        <div className="flex items-start gap-4 mb-6" data-id="element-379" data-mp="3cc9685ob2gxg">
          <div className="w-12 h-12 rounded-full bg-peach/10 text-peach flex items-center justify-center flex-shrink-0" data-id="element-380" data-mp="37c3hoydc1ajl">
            <Target size={22} data-id="element-381" data-mp="32cia5zk3jtv9" />
          </div>
          <div data-id="element-382" data-mp="32fw90xtjxkxy">
            <h3 className="text-2xl font-black text-warmBrown mb-1" data-id="element-383" data-mp="1vx7v8q8g24sh">
              Your Engagement Mix
            </h3>
            <p className="text-warmBrown/60 text-sm" data-id="element-384" data-mp="1qy3khv5vfz01">
              The exact ratio of content to watch, like, and comment on during
              warmup.
            </p>
          </div>
        </div>

        <div className="space-y-4" data-id="element-385" data-mp="benm3a1wm7l3">
          <EngagementBucket percent={30} label="Pets" color="peach" items={['Funny dog videos', 'Pet POV content', 'Pet-owner relatable content', 'Cute animal clips', 'Pet transformations']} goal="Tell TikTok you're interested in pet owners." data-id="element-386" data-mp="bfox5eix6u2t" />
          <EngagementBucket percent={30} label="Plushies & Stuffed Animals" color="coral" items={['Plushie collecting', 'Stuffed animal care', 'Plushie adventures', 'Comfort items', 'Cozy and nostalgic toy content']} goal="Reach people drawn to the comfort, care, security, and nostalgia of a beloved companion." data-id="element-387" data-mp="u43ndzley42k" />
          <EngagementBucket percent={20} label="Self-Care" color="lavender" items={['Water intake', 'Morning routines', 'Habit tracking', 'Self-improvement', 'Wellness content']} goal="Tell TikTok you're interested in people actively trying to improve themselves." data-id="element-388" data-mp="1bmk9cdstxtdo" />
          <EngagementBucket percent={20} label="Productivity / Mental Health" color="sage" items={['Atomic Habits', 'Motivation', 'Journaling', 'ADHD productivity', '"Get your life together" content']} goal="Reach the audience that actually installs apps." data-id="element-389" data-mp="sp9j1ip6eaad" />
        </div>
      </section>

      {/* Day 3 */}
      <PhaseCard phase="Day 3" title="Diagnostic Posting" color="peach" icon={<Camera size={24} data-id="element-391" data-mp="2gm8z8qg6rbcr" />} data-id="element-390" data-mp="293sqrhjyj7xx">
        <p className="text-warmBrown/80 leading-relaxed mb-4" data-id="element-392" data-mp="2gl7etvda5cid">
          Before posting real content, post <strong data-id="element-393" data-mp="2lmwq9c4ezs6z">2 slideshows</strong> (low
          production effort). These are diagnostic tools.
        </p>

        <div className="bg-cream/60 rounded-2xl p-6 mb-4" data-id="element-394" data-mp="27nwyvwpioz74">
          <p className="font-bold text-warmBrown mb-3" data-id="element-395" data-mp="2boh13eoy6t04">
            A slideshow "passed" if within 5 hours it gets:
          </p>
          <ul className="space-y-2" data-id="element-396" data-mp="2zf36szbhc16y">
            <li className="flex items-center gap-3 text-warmBrown/80" data-id="element-397" data-mp="34btizbk5ycn3">
              <span className="w-2 h-2 rounded-full bg-peach" data-id="element-398" data-mp="34dxo1wtsthoy"></span>
              <strong className="text-warmBrown" data-id="element-399" data-mp="2qk6nvf1yja5w">500+</strong> impressions
            </li>
            <li className="flex items-center gap-3 text-warmBrown/80" data-id="element-400" data-mp="2ukyyabmkfl3r">
              <span className="w-2 h-2 rounded-full bg-peach" data-id="element-401" data-mp="3ibcg79bfs3km"></span>
              <strong className="text-warmBrown" data-id="element-402" data-mp="3ia1ctalwkxu1">20–30+</strong> likes
            </li>
          </ul>
        </div>

        <div className="grid sm:grid-cols-2 gap-3" data-id="element-403" data-mp="segmcahgwd42">
          <div className="bg-sage/10 border border-sage/20 rounded-xl p-4" data-id="element-404" data-mp="sdp19tlhxxs1">
            <p className="text-sm font-bold text-sage mb-1" data-id="element-405" data-mp="weqrxm1cl1ie">✓ If it passes</p>
            <p className="text-sm text-warmBrown/80" data-id="element-406" data-mp="1160g0i78zws6">
              Post up to 3 main videos that same day.
            </p>
          </div>
          <div className="bg-coral/10 border border-coral/20 rounded-xl p-4" data-id="element-407" data-mp="1653mm72vmb29">
            <p className="text-sm font-bold text-coral mb-1" data-id="element-408" data-mp="9ge4qgr91iga">✗ If it fails</p>
            <p className="text-sm text-warmBrown/80" data-id="element-409" data-mp="dgegtuqvlhk6">
              Do one more day of observer mode. Your account is still cold.
            </p>
          </div>
        </div>
      </PhaseCard>

      {/* Day 4+ */}
      <PhaseCard phase="Day 4+" title="Active Posting" color="sage" icon={<Zap size={24} data-id="element-411" data-mp="1tvz7ek8x0600" />} data-id="element-410" data-mp="nfdrfiv7bn9t">
        <div className="space-y-4" data-id="element-412" data-mp="1tuxxij3mxpjv">
          <Rule icon={<Camera size={18} data-id="element-414" data-mp="1ytrckfyklom5" />} data-id="element-413" data-mp="1yuamb9e2h6p3">
            Post <strong data-id="element-415" data-mp="1yspo99sjn5mh">1–2 videos per day</strong>
          </Rule>
          <Rule icon={<Repeat size={18} data-id="element-417" data-mp="3jcl2ct49mgmk" />} data-id="element-416" data-mp="3jcurkehhkjr7">
            Continue the daily feed engagement routine (10 min, 2×/day) —{' '}
            <strong data-id="element-418" data-mp="3eejja86uahb3">this is not optional</strong>
          </Rule>
          <Rule icon={<TrendingUp size={18} data-id="element-420" data-mp="39m097l7d24b1" />} data-id="element-419" data-mp="39m8kj8nu51k4">
            Watch performance and adjust format based on what's holding viewers
          </Rule>
        </div>
      </PhaseCard>

      {/* Fast follower growth */}
      <section className="bg-white rounded-3xl p-8 md:p-10 shadow-soft border border-warmBrown/5" data-id="element-421" data-mp="30md5utv2mofc">
        <div className="flex items-start gap-4 mb-6" data-id="element-422" data-mp="2vmhatk4cq7bx">
          <div className="w-12 h-12 rounded-full bg-peach/10 text-peach flex items-center justify-center flex-shrink-0" data-id="element-423" data-mp="2votqtrqju7mc">
            <UserPlus size={22} data-id="element-424" data-mp="2lokso8czyc4b" />
          </div>
          <div data-id="element-425" data-mp="2lpunmoojz46q">
            <h3 className="text-2xl font-black text-warmBrown mb-1" data-id="element-426" data-mp="2lqdwlfw86i8m">
              Gaining Followers Quickly
            </h3>
            <p className="text-warmBrown/60 text-sm" data-id="element-427" data-mp="jx6iuaw9g8ou">
              How to get your UGC account past zero and actually start getting
              views.
            </p>
          </div>
        </div>

        <p className="text-warmBrown/80 leading-relaxed mb-6" data-id="element-428" data-mp="2j44w05bye0ed">
          Want to gain followers quickly on your UGC account and start actually
          getting views? Work the follower lists of creators who already have
          your exact audience.
        </p>

        <ol className="space-y-3 mb-6" data-id="element-429" data-mp="29elast0rpugc">
          {['Search the top creators in your niche.', 'Go through their recent followers and follow them.', 'Keep going until Meta and TikTok restrict you.', 'Set a recurring timer for one hour.', 'Repeat.'].map((step, idx) => <li key={step} className="flex items-start gap-3" data-id="element-430" data-mp="2s4jih80nlljg" data-mpi={idx}>
              <span className="mt-0.5 w-6 h-6 rounded-full bg-peach/15 text-peach flex items-center justify-center font-black text-xs flex-shrink-0" data-id="element-431" data-mp="2s6w909kh9484">
                {idx + 1}
              </span>
              <span className="text-warmBrown/80 leading-relaxed" data-id="element-432" data-mp="1gqz5ngbw6hrd">{step}</span>
            </li>)}
        </ol>

        <Callout color="peach" icon={<Target size={16} data-id="element-434" data-mp="147k5sa8ur2lt" />} title="Why it works" data-id="element-433" data-mp="14729jdm6wodw">
          People who recently followed a creator in your niche are already warm
          — they are actively looking for more of this content, so a meaningful
          share of them follow back.
        </Callout>
      </section>

      {/* Abandonment Rule */}
      <section className="bg-warmBrown rounded-3xl p-8 md:p-10 text-cream" data-id="element-435" data-mp="qgp0f7xkb3mz">
        <div className="flex items-start gap-4 mb-4" data-id="element-436" data-mp="lh2nz0pk5rf8">
          <div className="w-12 h-12 rounded-full bg-coral/20 text-coral flex items-center justify-center flex-shrink-0" data-id="element-437" data-mp="lidp0srmcl2n">
            <AlarmClockOff size={22} data-id="element-438" data-mp="veqknw6q5901" />
          </div>
          <div data-id="element-439" data-mp="vdypunkybfat">
            <h3 className="text-2xl font-black mb-1" data-id="element-440" data-mp="vdfig0sxg9b1">
              Account Abandonment Rule
            </h3>
            <p className="text-cream/60 text-sm" data-id="element-441" data-mp="7n1k5sjr1e80">
              When to cut your losses and restart.
            </p>
          </div>
        </div>

        <div className="space-y-4 text-cream/80 leading-relaxed" data-id="element-442" data-mp="324v8bv4ex8yx">
          <p data-id="element-443" data-mp="365nhkodabdv7">
            If <strong className="text-cream" data-id="element-444" data-mp="365dzro2e8d0l">6 consecutive videos</strong> stay
            under 300 views: post 3 videos recorded natively inside TikTok (no
            external edits, no CapCut). Sometimes this resets the trust signal.
          </p>
          <p data-id="element-445" data-mp="3fx1qfmr4lq10">
            If still nothing after those 3 videos:{' '}
            <strong className="text-cream" data-id="element-446" data-mp="3ktibg8313o9v">abandon the account</strong>. Restart
            costs 2 days. Staying on a dead account costs weeks.
          </p>
        </div>
      </section>

      {/* Retention Benchmark */}
      <section className="bg-gradient-to-br from-peach to-coral rounded-3xl p-8 md:p-10 text-white" data-id="element-447" data-mp="3tvrlyxyarhn9">
        <div className="inline-flex items-center gap-2 bg-white/20 backdrop-blur-sm px-3 py-1.5 rounded-full text-xs font-bold uppercase tracking-wider mb-4" data-id="element-448" data-mp="2of4ehti526t">
          <TrendingUp size={14} data-id="element-449" data-mp="24fs5sww9gry4" />
          Most Important Metric
        </div>
        <h3 className="text-3xl font-black mb-4" data-id="element-450" data-mp="1wwsnkukjd6gc">The Retention Benchmark</h3>
        <p className="text-white/90 leading-relaxed mb-6" data-id="element-451" data-mp="1wyvoi9n88jzu">
          TikTok distributes in waves. A video gets shown to a small test batch.
          If they watch to the end, it gets shown to a bigger batch.{' '}
          <strong className="text-white" data-id="element-452" data-mp="1i7wi959v67jf">This compounds.</strong>
        </p>

        <div className="bg-white/15 backdrop-blur-sm rounded-2xl p-6 mb-6 border border-white/20" data-id="element-453" data-mp="1i9pmyf0x2hos">
          <p className="text-sm uppercase tracking-wider text-white/70 font-bold mb-2" data-id="element-454" data-mp="2ftkf1ra8ervh">
            Target
          </p>
          <p className="text-4xl md:text-5xl font-black mb-2" data-id="element-455" data-mp="25xh2rslo1cut">42%+</p>
          <p className="text-white/90" data-id="element-456" data-mp="25vnuk8vemkkp">full video completion rate</p>
          <p className="text-sm text-white/70 mt-3" data-id="element-457" data-mp="21uu6nfhyp5rt">
            Below 42%, distribution waves stop. Above it, they compound.
          </p>
        </div>

        <h4 className="font-bold mb-3 text-white" data-id="element-458" data-mp="ufz95lxsttm0">Practical implications:</h4>
        <ul className="space-y-3 mb-6" data-id="element-459" data-mp="qffa2cto0fx8">
          <li className="flex items-start gap-3 text-white/90" data-id="element-460" data-mp="ry5ktkrh01fc">
            <span className="font-black text-white" data-id="element-461" data-mp="rvt1p49z7l0p">1.</span>
            <span data-id="element-462" data-mp="wvxlp4a3exvo">
              First <strong className="text-white" data-id="element-463" data-mp="ww7baqr8730u">3 seconds must hook</strong>{' '}
              (stop the scroll)
            </span>
          </li>
          <li className="flex items-start gap-3 text-white/90" data-id="element-464" data-mp="myj616vzud4f">
            <span className="font-black text-white" data-id="element-465" data-mp="n0vwy9jqbxtm">2.</span>
            <span data-id="element-466" data-mp="96d00dmk1mip">
              Middle must move{' '}
              <strong className="text-white" data-id="element-467" data-mp="dy4gtwfwsdvn">fast enough</strong> that dropping
              off feels like a loss
            </span>
          </li>
          <li className="flex items-start gap-3 text-white/90" data-id="element-468" data-mp="3vfxgpa8q95it">
            <span className="font-black text-white" data-id="element-469" data-mp="481ozzkix5yw">3.</span>
            <span data-id="element-470" data-mp="48l12znht050">
              Last <strong className="text-white" data-id="element-471" data-mp="3mdwj2c9l0hgm">3 seconds must earn</strong>{' '}
              the watch (payoff or pattern interrupt)
            </span>
          </li>
        </ul>

        <p className="text-white/90 leading-relaxed mb-4" data-id="element-472" data-mp="3qhm62xalyqzj">
          Slow middles kill videos that have great hooks.{' '}
          <strong className="text-white" data-id="element-473" data-mp="32s4it26duk82">Cut ruthlessly.</strong>
        </p>
        <p className="text-white/80 text-sm leading-relaxed" data-id="element-474" data-mp="32u7hsbpijnox">
          Likes and comments matter, but only as downstream effects of
          retention. Retention is the root signal.
        </p>

        <div className="mt-6 pt-6 border-t border-white/20" data-id="element-475" data-mp="3bux9p4bnktxd">
          <p className="text-sm uppercase tracking-wider text-white/70 font-bold mb-2" data-id="element-476" data-mp="3qp1tqrs72lu7">
            3-Second Watch-Time Benchmark
          </p>
          <p className="text-white/90 leading-relaxed" data-id="element-477" data-mp="3low5lll4vhgv">
            <strong className="text-white" data-id="element-478" data-mp="3by2x6wyiaj0">75–80%</strong> of viewers watching
            past the first 3 seconds = "viral-ready" format. Use this as the
            primary filter for what formats to scale.
          </p>
        </div>
      </section>

      {/* Daily Maintenance */}
      <PhaseCard phase="Daily" title="Maintenance (Forever)" color="lavender" icon={<Repeat size={24} data-id="element-480" data-mp="1fnhym5ugidub" />} data-id="element-479" data-mp="8cvircuhushc">
        <p className="text-warmBrown/80 leading-relaxed" data-id="element-481" data-mp="1fo9rh8wo5xgw">
          Warming up is not a one-time event. If you stop behaving like a human
          on the app (watching, liking, commenting), the account goes cold and
          performance drops.{' '}
          <strong className="text-warmBrown" data-id="element-482" data-mp="1tokm8n13nw7c">
            Treat daily feed engagement like brushing teeth.
          </strong>
        </p>
      </PhaseCard>

      {/* Comment Seeding */}
      <section className="bg-white rounded-3xl p-8 md:p-10 shadow-soft border border-warmBrown/5" data-id="element-483" data-mp="10zdmjkpwt0ki">
        <div className="flex items-start gap-4 mb-6" data-id="element-484" data-mp="15yzzdt1tsess">
          <div className="w-12 h-12 rounded-full bg-peach/10 text-peach flex items-center justify-center flex-shrink-0" data-id="element-485" data-mp="15xf94fmjni0q">
            <MessageSquare size={22} data-id="element-486" data-mp="1ar9lexztkups" />
          </div>
          <div data-id="element-487" data-mp="d99l9k071cwo">
            <h3 className="text-2xl font-black text-warmBrown mb-1" data-id="element-488" data-mp="d9sso6s7wiwg">
              Comment Seeding
            </h3>
            <p className="text-warmBrown/60 text-sm" data-id="element-489" data-mp="i72u6ksvsl0n">
              Turning curiosity into conversions.
            </p>
          </div>
        </div>

        <p className="text-warmBrown/80 leading-relaxed mb-6" data-id="element-490" data-mp="5qa13c4wrhc9">
          When a video gains traction but isn't converting, the issue is often a{' '}
          <strong className="text-warmBrown" data-id="element-491" data-mp="tjlsr0xgprw">
            lack of visible social proof
          </strong>{' '}
          in comments. Seed comments from secondary accounts.
        </p>

        <h4 className="font-bold text-warmBrown mb-3" data-id="element-492" data-mp="3nxhgpxna3qlx">
          Effective seed comments:
        </h4>
        <div className="space-y-2 mb-6" data-id="element-493" data-mp="3j44zw9ouco3q">
          {['what app is this??', 'does this actually work?', 'omg I need to try this with my cat', 'my dog would literally be perfect for this', 'anyone used this consistently? results?'].map(comment => <div key={comment} className="bg-cream/60 rounded-xl px-4 py-3 text-warmBrown/80 italic border-l-4 border-peach/40" data-id="element-494" data-mp="306kc75xtbvkp">
              "{comment}"
            </div>)}
        </div>

        <Callout color="sage" icon={<Sparkles size={18} data-id="element-496" data-mp="s63xi2e0ribh" />} title="Pro tip" data-id="element-495" data-mp="s6dl5jbldde0">
          Give Claude the hook of the video + your ICP + Pawchi description →
          generate an organic-sounding comment where the persona explains how
          the app helped them. This turns passive viewers into curious readers
          who then convert.
        </Callout>

        <p className="text-warmBrown font-bold mt-6 text-center" data-id="element-497" data-mp="1axwmzmtvqleg">
          No comments = no curiosity = no conversions.
        </p>
      </section>
    </motion.article>;
}
function ViralFormulaTopic() {
  const ingredients = [{
    label: 'Viral Feature',
    title: 'Real pet photo → animated AI sprite',
    desc: 'A "reveal moment" — identical in structure to face ratings, food scanners, or body analysis apps that generate millions of views. The reveal IS the ad.',
    icon: <Wand2 size={22} data-id="element-498" data-mp="3mptj0lpnkhf0" />,
    color: 'peach' as const
  }, {
    label: 'Core Desire',
    title: 'Love + identity + nostalgia',
    desc: 'Love for a real pet, desire for a self-care identity, and Tamagotchi nostalgia — three of the strongest emotional pulls online right now.',
    icon: <Heart size={22} data-id="element-499" data-mp="2fwt941dhizc6" />,
    color: 'coral' as const
  }, {
    label: 'Shareable Output',
    title: 'The animated pet sprite',
    desc: "The animated pet sprite, the pet's 'stats,' and the transformation itself — all inherently shareable across stories, group chats, and feeds.",
    icon: <Share2 size={22} data-id="element-500" data-mp="2uu3sry0a7biz" />,
    color: 'lavender' as const
  }];
  const formats = [{
    number: 1,
    priority: 'Highest Priority',
    title: 'The Transformation Reveal',
    structure: 'Real pet photo (before) → dramatic transition → animated Pawchi sprite (after)',
    hooks: ['"I turned my cat into a Tamagotchi... [she has opinions]"', '"POV you upload your dog\'s photo to this app"', '"This AI turned my actual cat into an animated version of herself and I\'m not okay"'],
    why: 'The reveal creates genuine delight and "I want to see mine" impulse. The comment section fills with "do mine!" requests organically. Highest-conversion format.',
    icon: <Wand2 size={22} data-id="element-501" data-mp="2creusnujkrny" />,
    color: 'peach' as const
  }, {
    number: 2,
    priority: 'Self-Care Angle',
    title: 'The Accountability Loop',
    structure: 'Morning routine or habit check-in, showing how completing habits makes the pet thrive',
    hooks: ['"My virtual pet died because I didn\'t drink water [I deserved it]"', '"Day 14 of letting my pet motivate my self-care routine"', '"What happens to your Pawchi when you skip your habits for 3 days"'],
    why: 'Demonstrates the core gameplay loop and the emotional stakes (pet declining hits hard). Creates relatability for anyone who struggles with habits.',
    icon: <Heart size={22} data-id="element-502" data-mp="3o44cg5unqn2o" />,
    color: 'coral' as const
  }, {
    number: 3,
    priority: 'Pet Identity',
    title: 'Slideshows',
    structure: '"If you\'re the kind of person who [trait]... your pet would be a [species/type]" — or — "What your self-care score says about your pet\'s personality"',
    hooks: [],
    why: 'Identity labeling creates instant engagement. People tag friends, share to stories, comment with their own results.',
    icon: <Tags size={22} data-id="element-503" data-mp="3a4v2hnx1op75" />,
    color: 'lavender' as const
  }, {
    number: 4,
    priority: 'App Demo',
    title: 'Screen Recording Demo',
    structure: 'Screen record of onboarding / pet customization with voiceover or text captions',
    hooks: ['"Okay this app genuinely got me to drink water for the first time in a week"'],
    why: "Shows the product in the most authentic, low-production way. Feels user-generated even when it isn't.",
    icon: <Monitor size={22} data-id="element-504" data-mp="2jdo0w5xcgo57" />,
    color: 'sage' as const
  }];
  const colorMap = {
    peach: {
      bg: 'bg-peach/10',
      text: 'text-peach',
      solid: 'bg-peach'
    },
    coral: {
      bg: 'bg-coral/10',
      text: 'text-coral',
      solid: 'bg-coral'
    },
    lavender: {
      bg: 'bg-lavender/10',
      text: 'text-lavender',
      solid: 'bg-lavender'
    },
    sage: {
      bg: 'bg-sage/10',
      text: 'text-sage',
      solid: 'bg-sage'
    }
  };
  return <motion.article initial={{
    opacity: 0,
    y: 20
  }} animate={{
    opacity: 1,
    y: 0
  }} transition={{
    duration: 0.4
  }} className="space-y-10" data-id="element-505" data-mp="1vo35uonx20fk">
      {/* Intro */}
      <header data-id="element-506" data-mp="1moq6wpxf4u93">
        <div className="inline-flex items-center gap-2 bg-peach/10 text-peach px-3 py-1.5 rounded-full text-xs font-bold uppercase tracking-wider mb-4" data-id="element-507" data-mp="1mozq9unyk35t">
          <Flame size={14} data-id="element-508" data-mp="3h0wkfvdsbn4k" />
          Growth Strategy
        </div>
        <h2 className="text-3xl md:text-4xl font-black text-warmBrown mb-4" data-id="element-509" data-mp="3gzlfvtcimbce">
          The Viral Formula for Pawchi
        </h2>
        <p className="text-warmBrown/80 text-lg leading-relaxed" data-id="element-510" data-mp="17s87dpkfyk58">
          Every viral product on TikTok and Reels follows the same recipe.{' '}
          <strong className="text-warmBrown" data-id="element-511" data-mp="1ck9sm0zl7l7e">
            Pawchi has all three ingredients.
          </strong>{' '}
          Here's how to use them.
        </p>
      </header>

      {/* Formula equation */}
      <section className="bg-white rounded-3xl p-8 md:p-10 shadow-soft border border-warmBrown/5" data-id="element-512" data-mp="jwngu5g7ha9g">
        <p className="text-xs font-bold uppercase tracking-wider text-warmBrown/40 mb-6" data-id="element-513" data-mp="ovzzsf3yhx6r">
          The Formula
        </p>
        <div className="flex flex-wrap items-center gap-3 md:gap-4 text-warmBrown" data-id="element-514" data-mp="xuke742hhkp6">
          <span className="px-4 py-2 bg-peach/10 text-peach rounded-xl font-bold text-sm md:text-base" data-id="element-515" data-mp="xs7lpwz3nrxv">
            Viral Feature
          </span>
          <Plus size={18} className="text-warmBrown/40" data-id="element-516" data-mp="298xu9mqzwvun" />
          <span className="px-4 py-2 bg-coral/10 text-coral rounded-xl font-bold text-sm md:text-base" data-id="element-517" data-mp="29bk0nj25h5ba">
            Core Human Desire
          </span>
          <Plus size={18} className="text-warmBrown/40" data-id="element-518" data-mp="554ffv1lcqp5" />
          <span className="px-4 py-2 bg-lavender/10 text-lavender rounded-xl font-bold text-sm md:text-base" data-id="element-519" data-mp="j5nnv39yxyru">
            Shareable Output
          </span>
          <Equal size={18} className="text-warmBrown/40" data-id="element-520" data-mp="e73wuogipwsm" />
          <span className="px-4 py-2 bg-warmBrown text-cream rounded-xl font-bold text-sm md:text-base" data-id="element-521" data-mp="3mlupl48tplxz">
            Organic Growth Machine
          </span>
        </div>
      </section>

      {/* Three ingredients */}
      <section data-id="element-522" data-mp="7urykxrip3y">
        <h3 className="text-2xl font-black text-warmBrown mb-6" data-id="element-523" data-mp="8e0xc5fq35u">
          How Pawchi checks every box
        </h3>
        <div className="grid md:grid-cols-3 gap-4" data-id="element-524" data-mp="3rje1vylynona">
          {ingredients.map(item => {
          const c = colorMap[item.color];
          return <div key={item.label} className="bg-white rounded-3xl p-6 shadow-soft border border-warmBrown/5 flex flex-col" data-id="element-525" data-mp="2yvrzuusdss2j">
                <div className={`w-12 h-12 rounded-full ${c.bg} ${c.text} flex items-center justify-center mb-4`} data-id="element-526" data-mp="1j57lytqyuzle">
                  {item.icon}
                </div>
                <p className={`text-xs font-bold uppercase tracking-wider ${c.text} mb-1`} data-id="element-527" data-mp="19fei6ex2forp">
                  {item.label}
                </p>
                <h4 className="font-black text-warmBrown mb-2 leading-tight" data-id="element-528" data-mp="1x3fkv77kcaz7">
                  {item.title}
                </h4>
                <p className="text-sm text-warmBrown/70 leading-relaxed" data-id="element-529" data-mp="1o53rwyj8513l">
                  {item.desc}
                </p>
              </div>;
        })}
        </div>
      </section>

      {/* Reveal mechanic */}
      <section className="bg-gradient-to-br from-peach to-coral rounded-3xl p-8 md:p-10 text-white" data-id="element-530" data-mp="com57q5ficu5">
        <div className="inline-flex items-center gap-2 bg-white/20 backdrop-blur-sm px-3 py-1.5 rounded-full text-xs font-bold uppercase tracking-wider mb-4" data-id="element-531" data-mp="hp9vg9lu2pnb">
          <Sparkles size={14} data-id="element-532" data-mp="14cgqomi1rapw" />
          Highest Priority
        </div>
        <h3 className="text-3xl font-black mb-4" data-id="element-533" data-mp="14fcped1py3fe">The Reveal Mechanic</h3>
        <p className="text-white/90 leading-relaxed mb-6" data-id="element-534" data-mp="zef5nw1291bs">
          The single most viral moment in Pawchi is the transformation: user
          uploads real pet photo → Pawchi generates animated sprite. This is
          your{' '}
          <strong className="text-white" data-id="element-535" data-mp="1n3hmj1nveq58">UMax "face rating reveal,"</strong>{' '}
          your <strong className="text-white" data-id="element-536" data-mp="1n5kkq8z6fpl1">Cal AI "calorie reveal."</strong>
        </p>
        <div className="bg-white/15 backdrop-blur-sm rounded-2xl p-6 border border-white/20 mb-6" data-id="element-537" data-mp="1iawy6fnqh593">
          <p className="font-bold text-lg leading-snug" data-id="element-538" data-mp="1ddemwim8udxx">
            Every ad creative, every organic video, every influencer brief must
            center on this reveal.{' '}
            <span className="block mt-2" data-id="element-539" data-mp="261k7949dy0x8">
              Do not show features. Show the reveal.
            </span>
          </p>
        </div>
        <div data-id="element-540" data-mp="2dfuumuogbrvr">
          <p className="text-sm uppercase tracking-wider text-white/70 font-bold mb-2" data-id="element-541" data-mp="2icbgfi86hu5o">
            Why it works
          </p>
          <p className="text-white/90 leading-relaxed" data-id="element-542" data-mp="2namr1v6as8oy">
            TikTok and Reels are dopamine delivery systems. The reveal gives
            viewers a reason to watch to the end, and a reason to comment{' '}
            <em className="text-white" data-id="element-543" data-mp="2wbkyyojux0ct">("omg do mine," "what is this app")</em>.
            Both behaviors drive algorithmic distribution.
          </p>
        </div>
      </section>

      {/* Four formats intro */}
      <section data-id="element-544" data-mp="362nvdd1ucr5r">
        <h3 className="text-2xl md:text-3xl font-black text-warmBrown mb-2" data-id="element-545" data-mp="3648r35zw6g57">
          The Four Organic Formats
        </h3>
        <p className="text-warmBrown/70 leading-relaxed mb-8" data-id="element-546" data-mp="3g0lk01nm4pyw">
          Ranked by priority. Mix and match these for your weekly content
          schedule.
        </p>

        <div className="space-y-5" data-id="element-547" data-mp="3jzufpc27qxx3">
          {formats.map(format => {
          const c = colorMap[format.color];
          return <article key={format.number} className="bg-white rounded-3xl p-8 shadow-soft border border-warmBrown/5" data-id="element-548" data-mp="vlb199x0w5bc">
                <div className="flex items-start gap-4 mb-5" data-id="element-549" data-mp="gpvcnkf7p1mc">
                  <div className={`w-14 h-14 rounded-2xl ${c.solid} text-white flex items-center justify-center flex-shrink-0 font-black text-xl`} data-id="element-550" data-mp="ln3vzoc3jbp6">
                    {format.number}
                  </div>
                  <div className="flex-1 min-w-0" data-id="element-551" data-mp="zmd3lzm8kxhj">
                    <p className={`text-xs font-bold uppercase tracking-wider ${c.text} mb-1`} data-id="element-552" data-mp="zltsp2v079d0">
                      Format {format.number} · {format.priority}
                    </p>
                    <h4 className="text-xl md:text-2xl font-black text-warmBrown" data-id="element-553" data-mp="1s97huesgn0mk">
                      {format.title}
                    </h4>
                  </div>
                </div>

                <div className="mb-5" data-id="element-554" data-mp="3hq32sb8uviet">
                  <p className="text-xs font-bold uppercase tracking-wider text-warmBrown/40 mb-2" data-id="element-555" data-mp="3ctl0di0zzw5n">
                    Structure
                  </p>
                  <p className="text-warmBrown/80 leading-relaxed" data-id="element-556" data-mp="3rh60d32ktf9c">
                    {format.structure}
                  </p>
                </div>

                {format.hooks.length > 0 && <div className="mb-5" data-id="element-557" data-mp="2ytjzi2kqgoq6">
                    <p className="text-xs font-bold uppercase tracking-wider text-warmBrown/40 mb-3" data-id="element-558" data-mp="2tugwenobcsku">
                      Hook options
                    </p>
                    <div className="space-y-2" data-id="element-559" data-mp="37rvmzvqaz6ee">
                      {format.hooks.map(hook => <div key={hook} className={`bg-cream/60 rounded-xl px-4 py-3 text-warmBrown/80 italic border-l-4 ${c.text.replace('text-', 'border-')}/40`} data-id="element-560" data-mp="33uhiuihhbot9">
                          {hook}
                        </div>)}
                    </div>
                  </div>}

                <div className={`${c.bg} rounded-2xl p-5`} data-id="element-561" data-mp="3gxtst4km2vk4">
                  <div className="flex items-center gap-2 mb-2" data-id="element-562" data-mp="3lvvb3na7qquj">
                    <Lightbulb size={16} className={c.text} data-id="element-563" data-mp="3pw5gaxq6ld8c" />
                    <p className={`font-bold text-sm ${c.text}`} data-id="element-564" data-mp="3pvm9ac22k993">
                      Why it works
                    </p>
                  </div>
                  <p className="text-warmBrown/80 text-sm leading-relaxed" data-id="element-565" data-mp="2y4pvn986q0kr">
                    {format.why}
                  </p>
                </div>
              </article>;
        })}
        </div>
      </section>
    </motion.article>;
}
function HooksTopic() {
  const categories = [{
    label: 'Emotional / Attachment',
    icon: <HeartHandshake size={22} data-id="element-566" data-mp="2afetpof3m051" />,
    color: 'coral' as const,
    hooks: ['"I cried when I saw my cat as an animated character [she has her exact markings]"', '"This app turned my dead dog into a living animated version of him [I\'m not okay]"', '"POV: your actual pet becomes your virtual self-care companion"']
  }, {
    label: 'Accountability / Consequence',
    icon: <AlertCircle size={22} data-id="element-567" data-mp="1xyvxmnal83vu" />,
    color: 'peach' as const,
    hooks: ['"My virtual pet literally got sick because I didn\'t sleep enough [I deserved it]"', '"The only thing that made me actually do my morning routine is not wanting to let my cat down"', '"What happens to your Pawchi when you skip days [warning: sad]"']
  }, {
    label: 'Curiosity / Transformation',
    icon: <HelpCircle size={22} data-id="element-568" data-mp="1a7qdhvxm6pfq" />,
    color: 'lavender' as const,
    hooks: ['"Watch me turn my dog into a Tamagotchi [AI did this in 10 seconds]"', '"I uploaded my cat\'s photo and now I have to take care of her digitally"', '"This app is literally Tamagotchi but your actual pet [how is this free]"']
  }, {
    label: 'Nostalgia',
    icon: <Gamepad2 size={22} data-id="element-569" data-mp="35an4j9wsu51d" />,
    color: 'sage' as const,
    hooks: ['"Tamagotchi but it\'s YOUR actual pet and it\'s connected to your real habits"', '"Grew up with Tamagotchis, now I have one but it looks exactly like my dog"', '"POV: it\'s 2006 and your Tamagotchi is your actual cat"']
  }, {
    label: 'Identity',
    icon: <Fingerprint size={22} data-id="element-570" data-mp="2hjr6hv1r2dlo" />,
    color: 'peach' as const,
    hooks: ['"Self-care apps never worked for me until my cat\'s wellbeing depended on it"', '"I\'m a terrible habit person but I\'ve been consistent for 30 days because of this app"', '"Turns out the only accountability system I needed was a virtual version of my own pet"']
  }];
  const colorMap = {
    peach: {
      bg: 'bg-peach/10',
      text: 'text-peach',
      border: 'border-peach/40'
    },
    coral: {
      bg: 'bg-coral/10',
      text: 'text-coral',
      border: 'border-coral/40'
    },
    lavender: {
      bg: 'bg-lavender/10',
      text: 'text-lavender',
      border: 'border-lavender/40'
    },
    sage: {
      bg: 'bg-sage/10',
      text: 'text-sage',
      border: 'border-sage/40'
    }
  };
  const commentBait = ['Flash a leaderboard showing a rival pet beating the user\'s pet (provokes "how do you compete?" comments)', 'Show a strange/unexpected pet name or stat combination', 'Show the pet\'s "disapproval" animation', 'Anything that makes viewers feel they saw something and need to comment about it'];
  return <motion.article initial={{
    opacity: 0,
    y: 20
  }} animate={{
    opacity: 1,
    y: 0
  }} transition={{
    duration: 0.4
  }} className="space-y-10" data-id="element-571" data-mp="2o0sod5ygtvib">
      {/* Intro */}
      <header data-id="element-572" data-mp="ooggudocx41l">
        <div className="inline-flex items-center gap-2 bg-peach/10 text-peach px-3 py-1.5 rounded-full text-xs font-bold uppercase tracking-wider mb-4" data-id="element-573" data-mp="ooq6g05hp96r">
          <Anchor size={14} data-id="element-574" data-mp="1eef5qy8htir2" />
          Hook Library
        </div>
        <h2 className="text-3xl md:text-4xl font-black text-warmBrown mb-4" data-id="element-575" data-mp="1iez4254syses">
          Hooks &amp; Viral Angles
        </h2>
        <p className="text-warmBrown/80 text-lg leading-relaxed" data-id="element-576" data-mp="1nbphekp839wi">
          The first 3 seconds decide everything. Swipe these{' '}
          <strong className="text-warmBrown" data-id="element-577" data-mp="1xb6nv4catrtj">
            highest-leverage hook angles
          </strong>{' '}
          for Pawchi, then customize them with details about your specific pet.
        </p>
      </header>

      {/* Hook categories */}
      <section className="space-y-5" data-id="element-578" data-mp="264tbu8a9lqs6">
        {categories.map(cat => {
        const c = colorMap[cat.color];
        return <article key={cat.label} className="bg-white rounded-3xl p-8 shadow-soft border border-warmBrown/5" data-id="element-579" data-mp="2b4fp2hq3f70z">
              <div className="flex items-center gap-4 mb-5" data-id="element-580" data-mp="2l1kfitqz1onl">
                <div className={`w-12 h-12 rounded-full ${c.bg} ${c.text} flex items-center justify-center flex-shrink-0`} data-id="element-581" data-mp="9d5unmkppu6s">
                  {cat.icon}
                </div>
                <h3 className="text-xl md:text-2xl font-black text-warmBrown" data-id="element-582" data-mp="3vk430hc66tnm">
                  {cat.label} Hooks
                </h3>
              </div>

              <div className="space-y-2" data-id="element-583" data-mp="3qnnf9o8vuhb2">
                {cat.hooks.map(hook => <div key={hook} className={`bg-cream/60 rounded-xl px-4 py-3 text-warmBrown/80 italic border-l-4 ${c.border}`} data-id="element-584" data-mp="s35e9txsah2t">
                    {hook}
                  </div>)}
              </div>
            </article>;
      })}
      </section>

      {/* Hook structure formula */}
      <section className="bg-gradient-to-br from-peach to-coral rounded-3xl p-8 md:p-10 text-white" data-id="element-585" data-mp="1avgbb75rbkt0">
        <div className="inline-flex items-center gap-2 bg-white/20 backdrop-blur-sm px-3 py-1.5 rounded-full text-xs font-bold uppercase tracking-wider mb-4" data-id="element-586" data-mp="162n5efyjy6fc">
          <Sparkles size={14} data-id="element-587" data-mp="j6tsaufzef4c" />
          The Formula
        </div>
        <h3 className="text-3xl font-black mb-4" data-id="element-588" data-mp="j84x8xl5xsx1">Hook Structure Formula</h3>
        <p className="text-white/90 leading-relaxed mb-6" data-id="element-589" data-mp="5gqb4hvylblr">
          For Pawchi specifically, the highest-performing hook pattern is:
        </p>

        <div className="flex flex-wrap items-center gap-2 md:gap-3 mb-8" data-id="element-590" data-mp="y44d4ueikxcq">
          <span className="px-4 py-2 bg-white/20 backdrop-blur-sm rounded-xl font-bold text-sm md:text-base border border-white/30" data-id="element-591" data-mp="y4vv32f6uwkj">
            Specific personal detail
          </span>
          <Plus size={18} className="text-white/60" data-id="element-592" data-mp="o5erqrnesurq" />
          <span className="px-4 py-2 bg-white/20 backdrop-blur-sm rounded-xl font-bold text-sm md:text-base border border-white/30" data-id="element-593" data-mp="t4rihnheilzl">
            Surprising outcome
          </span>
          <Plus size={18} className="text-white/60" data-id="element-594" data-mp="3dv8p108kzlda" />
          <span className="px-4 py-2 bg-white/20 backdrop-blur-sm rounded-xl font-bold text-sm md:text-base border border-white/30" data-id="element-595" data-mp="3dw1mtbpkb0ja">
            Implicit challenge / FOMO
          </span>
        </div>

        <div className="bg-white/15 backdrop-blur-sm rounded-2xl p-6 border border-white/20" data-id="element-596" data-mp="31buzxj6zqvz2">
          <p className="text-sm uppercase tracking-wider text-white/70 font-bold mb-3" data-id="element-597" data-mp="3fb4fcgndhm1z">
            Example
          </p>
          <p className="text-white/95 leading-relaxed italic" data-id="element-598" data-mp="3ae4a27ycknbx">
            "I uploaded my{' '}
            <strong className="text-white not-italic bg-white/20 px-1.5 py-0.5 rounded" data-id="element-599" data-mp="2mo02jpi1g3fn">
              grey tabby's photo
            </strong>{' '}
            [specific] and she now has{' '}
            <strong className="text-white not-italic bg-white/20 px-1.5 py-0.5 rounded" data-id="element-600" data-mp="2wf4lf0au48fr">
              her exact markings in the app
            </strong>{' '}
            [surprising] and{' '}
            <strong className="text-white not-italic bg-white/20 px-1.5 py-0.5 rounded" data-id="element-601" data-mp="23vo2xairrg97">
              my water intake has never been higher
            </strong>{' '}
            [FOMO/outcome]"
          </p>
        </div>
      </section>

      {/* Comment bait */}
      <section className="bg-white rounded-3xl p-8 md:p-10 shadow-soft border border-warmBrown/5" data-id="element-602" data-mp="qfespme3y5jf">
        <div className="flex items-start gap-4 mb-5" data-id="element-603" data-mp="154awv8d1myer">
          <div className="w-12 h-12 rounded-full bg-lavender/10 text-lavender flex items-center justify-center flex-shrink-0" data-id="element-604" data-mp="155vwhce7t7jh">
            <MessageSquare size={22} data-id="element-605" data-mp="1e47hmywbbd4j" />
          </div>
          <div data-id="element-606" data-mp="1e2whra5zmpip">
            <h3 className="text-2xl font-black text-warmBrown mb-1" data-id="element-607" data-mp="1e6k8y2nymzu9">
              Comment Bait Elements
            </h3>
            <p className="text-warmBrown/60 text-sm" data-id="element-608" data-mp="1o2nd1e2dh8ju">
              Hide something that provokes a reaction.
            </p>
          </div>
        </div>

        <p className="text-warmBrown/80 leading-relaxed mb-6" data-id="element-609" data-mp="1j43l8x13l2jk">
          Hide something in the video that provokes comments. It{' '}
          <strong className="text-warmBrown" data-id="element-610" data-mp="3pvuxf1wuegcl">
            does not need to be related to the app
          </strong>
          :
        </p>

        <ul className="space-y-3 mb-6" data-id="element-611" data-mp="20dxs2adjjzpy">
          {commentBait.map(item => <li key={item} className="flex items-start gap-3" data-id="element-612" data-mp="25citue8fyrgi">
              <span className="mt-2 w-2 h-2 rounded-full bg-lavender flex-shrink-0" data-id="element-613" data-mp="25e2dmetb3kn1"></span>
              <span className="text-warmBrown/80 leading-relaxed" data-id="element-614" data-mp="1ql0hcqesjf1w">{item}</span>
            </li>)}
        </ul>

        <div className="bg-warmBrown rounded-2xl p-5 text-cream" data-id="element-615" data-mp="1hmeqm7z60tq1">
          <p className="font-bold text-center text-lg" data-id="element-616" data-mp="1hktysq48jovv">
            Comments → engagement → cheaper CPM on ads → more distribution.
          </p>
        </div>
      </section>
    </motion.article>;
}
function FinchPawchiTopic() {
  const pairs = [{
    finch: 'Nobody: That one person who remembers to drink water because a bird on her phone told her to',
    pawchi: 'Nobody: That one person drinking water because a pixel version of her dog is judging her',
    referenceUrl: 'https://www.tiktok.com/@finchcare/video/7618231189844806926'
  }, {
    finch: 'Me trying to drink water so I can get more rainbow stones on Finch',
    pawchi: 'Me chugging water because I turned my dog into a Tamagotchi',
    referenceUrl: 'https://www.tiktok.com/@finchcare/video/7644182635153001742'
  }, {
    finch: 'Making my stupid bed so my Finch can get back from her stupid adventure',
    pawchi: 'Making my stupid bed because my dog somehow lives in my phone now',
    referenceUrl: 'https://www.tiktok.com/@madiebooth/video/7474039283083529503'
  }, {
    finch: 'Rotting in bed? Not anymore thanks to this cute self care app',
    pawchi: "Rotting in bed? My dog won't let me anymore",
    referenceUrl: 'https://www.tiktok.com/@finchcare/video/7457035886274907438'
  }, {
    finch: 'POV: your sink is overflowing with dishes and the only motivation to wash them is because of a silly little bird on your phone',
    pawchi: "POV: the only reason these dishes are getting done is because my dog gets sad when I don't",
    referenceUrl: 'https://www.tiktok.com/@finchcare/video/7642362206276881678'
  }, {
    finch: 'Me trying to act nonchalant but I literally have a bird on my phone reminding me to drink water',
    pawchi: 'Me trying to explain why a digital version of my dog controls my life',
    referenceUrl: 'https://www.tiktok.com/@finchcare/video/7644182635153001742'
  }, {
    finch: 'Download a silly little self care app not expecting it to work',
    pawchi: 'Downloaded an app that turned my dog into a virtual pet. Somehow my life is together now',
    referenceUrl: 'https://www.tiktok.com/@finchcare/video/7263861893255761194'
  }, {
    finch: 'I love being a girl in 2026 because someone made a Studio Ghibli self care app',
    pawchi: 'I love being alive in 2026 because I can turn my dog into a Tamagotchi',
    referenceUrl: 'https://www.tiktok.com/@reb.ponyo/video/7627477323406642445'
  }, {
    finch: 'POV: this silly goofy bird on your phone is the reason why you remember to treat yourself',
    pawchi: "POV: my dog has absolutely no idea he's responsible for my mental health now",
    referenceUrl: 'https://www.tiktok.com/@finchcare/video/7619002656144575758'
  }, {
    finch: "Checks my birb to see if she's done with her adventure",
    pawchi: 'Checking if my dog survived the day after I forgot to drink water',
    referenceUrl: 'https://www.tiktok.com/@finchcare/video/7129210768452521259'
  }];
  const bonusReferences = [{
    caption: 'Me, stressy, depressy and unmotivated',
    url: 'https://www.tiktok.com/@finchcare/video/7068061545644707118',
    handle: '@finchcare'
  }, {
    caption: 'Me: last year, "I wish I was healthier"',
    url: 'https://www.tiktok.com/@tylerandgerald/video/7314567467391700270',
    handle: '@tylerandgerald'
  }, {
    caption: 'Making my stupid bed',
    url: 'https://www.tiktok.com/@finchcare/video/7213858957826329899',
    handle: '@finchcare'
  }];
  function getHandle(url: string) {
    const match = url.match(/@([^/]+)/);
    return match ? `@${match[1]}` : '';
  }
  return <motion.article initial={{
    opacity: 0,
    y: 20
  }} animate={{
    opacity: 1,
    y: 0
  }} transition={{
    duration: 0.4
  }} className="space-y-10" data-id="element-617" data-mp="9dsjkvru2i23">
      {/* Intro */}
      <header data-id="element-618" data-mp="kpa0ykb6pcq">
        <div className="inline-flex items-center gap-2 bg-lavender/10 text-lavender px-3 py-1.5 rounded-full text-xs font-bold uppercase tracking-wider mb-4" data-id="element-619" data-mp="kyr1wndlm6a">
          <Copy size={14} data-id="element-620" data-mp="sc4x0tps2e3h" />
          Swipe File
        </div>
        <h2 className="text-3xl md:text-4xl font-black text-warmBrown mb-4" data-id="element-621" data-mp="x33brov4b44m">
          Finch → Pawchi Examples
        </h2>
        <p className="text-warmBrown/80 text-lg leading-relaxed" data-id="element-622" data-mp="16zlnft2om0tt">
          Finch's UGC playbook is already proven. We've remixed{' '}
          <strong className="text-warmBrown" data-id="element-623" data-mp="12y04pr3gusbp">
            {pairs.length} of their top-performing caption styles
          </strong>{' '}
          for Pawchi. Use them as templates — swap in your pet's details and
          post.
        </p>
      </header>

      {/* Pawchi creator spotlight */}
      <section className="bg-white rounded-3xl p-8 md:p-10 shadow-soft border border-peach/20" data-id="element-624" data-mp="o10x438m6zh8">
        <div className="flex items-start gap-4 mb-6" data-id="element-625" data-mp="j8pqkhjdcffp">
          <div className="w-12 h-12 rounded-full bg-peach/10 text-peach flex items-center justify-center flex-shrink-0" data-id="element-626" data-mp="f7nycknvd3n8">
            <Sparkles size={22} data-id="element-627" data-mp="a9m5j80n5pyk" />
          </div>
          <div data-id="element-628" data-mp="a6q7zksph3an">
            <h3 className="text-2xl font-black text-warmBrown mb-1" data-id="element-629" data-mp="59qavzdu3avo">
              Pawchi Creator Spotlight
            </h3>
            <p className="text-warmBrown/60 text-sm" data-id="element-630" data-mp="a53r1oifw7v">
              Start here — a creator already making Pawchi content. Study their
              pacing, tone, and hooks.
            </p>
          </div>
        </div>

        <a href="https://www.tiktok.com/@laneyand_toby" target="_blank" rel="noopener noreferrer" className="group flex items-center justify-between gap-4 p-5 bg-peach/10 hover:bg-peach/15 rounded-2xl border border-peach/30 transition-colors" data-id="element-631" data-mp="3ra5q2ju0whz7">
          <div className="flex items-center gap-4 min-w-0" data-id="element-632" data-mp="33mnxwn6ujhvp">
            <div className="w-11 h-11 rounded-xl bg-white text-peach flex items-center justify-center flex-shrink-0 shadow-soft" data-id="element-633" data-mp="38kpg75wg7d64">
              <PawPrint size={20} data-id="element-634" data-mp="3djircro9is34" />
            </div>
            <div className="min-w-0" data-id="element-635" data-mp="3dhxyr7lidj7w">
              <p className="font-black text-warmBrown truncate" data-id="element-636" data-mp="3iar49xoswvl1">
                @laneyand_toby
              </p>
              <p className="text-sm text-warmBrown/60" data-id="element-637" data-mp="2ku27iiepkjii">
                Active Pawchi UGC creator on TikTok
              </p>
            </div>
          </div>
          <ArrowRight size={18} className="text-peach group-hover:translate-x-1 transition-transform flex-shrink-0" data-id="element-638" data-mp="7vagbsao3thg" />
        </a>

        <Callout color="lavender" icon={<Lightbulb size={16} data-id="element-640" data-mp="htznaq10ztix" />} title="What to take from it" data-id="element-639" data-mp="3vi332abwz5r">
          Watch how they open a video, how quickly they get to the companion,
          and how naturally the self-care angle comes through.{' '}
          <strong data-id="element-641" data-mp="qstqiz8v3i5g">Borrow the structure, not the script</strong> — your version
          should sound like you.
        </Callout>
      </section>

      {/* Legend */}
      <div className="grid sm:grid-cols-2 gap-3" data-id="element-642" data-mp="10job7z6gm9os">
        <div className="bg-white rounded-2xl p-4 border border-warmBrown/10 flex items-center gap-3" data-id="element-643" data-mp="10j694lx4918y">
          <div className="w-10 h-10 rounded-full bg-warmBrown/10 text-warmBrown/60 flex items-center justify-center flex-shrink-0" data-id="element-644" data-mp="vlmuhkwiamgh">
            <Bird size={20} data-id="element-645" data-mp="15j0wwgllhaps" />
          </div>
          <div data-id="element-646" data-mp="15kc1ujqs0oih">
            <p className="text-xs font-bold uppercase tracking-wider text-warmBrown/40" data-id="element-647" data-mp="15kvnaafmxv19">
              Original
            </p>
            <p className="font-bold text-warmBrown text-sm" data-id="element-648" data-mp="1t6fpvfhmx26q">Finch caption</p>
          </div>
        </div>
        <div className="bg-white rounded-2xl p-4 border border-peach/30 flex items-center gap-3" data-id="element-649" data-mp="1f6n31v98b641">
          <div className="w-10 h-10 rounded-full bg-peach/10 text-peach flex items-center justify-center flex-shrink-0" data-id="element-650" data-mp="1k5raagcletrq">
            <PawPrint size={20} data-id="element-651" data-mp="15glel2cyrlol" />
          </div>
          <div data-id="element-652" data-mp="15eqs3jm1nlie">
            <p className="text-xs font-bold uppercase tracking-wider text-peach" data-id="element-653" data-mp="15f0mrki1aguf">
              Remixed
            </p>
            <p className="font-bold text-warmBrown text-sm" data-id="element-654" data-mp="wgf1hhl6gnpy">Pawchi variant</p>
          </div>
        </div>
      </div>

      {/* Comparison pairs */}
      <section className="space-y-5" data-id="element-655" data-mp="11frtegqwokze">
        {pairs.map((pair, index) => <article key={index} className="bg-white rounded-3xl p-6 md:p-8 shadow-soft border border-warmBrown/5" data-id="element-656" data-mp="mj0s21xo8z75" data-mpi={index}>
            <div className="flex items-center gap-3 mb-5" data-id="element-657" data-mp="ncmswsqyuu0w">
              <span className="w-8 h-8 rounded-full bg-warmBrown text-cream flex items-center justify-center font-black text-sm" data-id="element-658" data-mp="ne7o8kl3ugzt">
                {index + 1}
              </span>
              <span className="text-xs font-bold uppercase tracking-wider text-warmBrown/40" data-id="element-659" data-mp="x9ri71g3z5lx">
                Caption Pair
              </span>
            </div>

            <div className="grid md:grid-cols-[1fr_auto_1fr] gap-4 md:gap-5 items-stretch" data-id="element-660" data-mp="16bikrxfcqwbk">
              {/* Finch side */}
              <div className="bg-cream/60 rounded-2xl p-5 border border-warmBrown/10" data-id="element-661" data-mp="1b9twkdp7jgwf">
                <div className="flex items-center gap-2 mb-3" data-id="element-662" data-mp="1g0sefhpugn1s">
                  <Bird size={16} className="text-warmBrown/40" data-id="element-663" data-mp="1g3ewibad2ky9" />
                  <p className="text-xs font-bold uppercase tracking-wider text-warmBrown/40" data-id="element-664" data-mp="1kz3p1unyr1l2">
                    Finch
                  </p>
                </div>
                <p className="text-warmBrown/80 italic leading-relaxed" data-id="element-665" data-mp="1u0tpfpztpauz">
                  "{pair.finch}"
                </p>
              </div>

              {/* Arrow */}
              <div className="flex md:flex-col items-center justify-center text-peach md:py-4" data-id="element-666" data-mp="3egriuj9bjm92">
                <ArrowRight size={24} className="md:hidden" data-id="element-667" data-mp="39mduv1wzkhef" />
                <ArrowRight size={24} className="hidden md:block" data-id="element-668" data-mp="35j8sr0gtihqb" />
              </div>

              {/* Pawchi side */}
              <div className="bg-peach/10 rounded-2xl p-5 border border-peach/30" data-id="element-669" data-mp="30l7a2gnb0kfd">
                <div className="flex items-center justify-between gap-2 mb-3" data-id="element-670" data-mp="13pt4tbthh2w">
                  <div className="flex items-center gap-2" data-id="element-671" data-mp="3t9341dlhny8g">
                    <PawPrint size={16} className="text-peach" data-id="element-672" data-mp="3ohbmtto834uz" />
                    <p className="text-xs font-bold uppercase tracking-wider text-peach" data-id="element-673" data-mp="3ofh1wfcybcqw">
                      Pawchi
                    </p>
                  </div>
                  {pair.referenceUrl && <a href={pair.referenceUrl} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-1 text-xs font-bold text-peach hover:text-coral transition-colors" data-id="element-674" data-mp="kubbu4x6p5r2">
                      <Film size={12} data-id="element-675" data-mp="13yo8yeuq4jfw" />
                      <span data-id="element-676" data-mp="q68dbz45jnp0">{getHandle(pair.referenceUrl)}</span>
                    </a>}
                </div>
                <p className="text-warmBrown leading-relaxed font-medium" data-id="element-677" data-mp="u5h6p2va5jk1">
                  "{pair.pawchi}"
                </p>
              </div>
            </div>
          </article>)}
      </section>

      {/* Pawchi-original captions */}
      <section className="bg-white rounded-3xl p-8 md:p-10 shadow-soft border border-warmBrown/5" data-id="element-678" data-mp="76uf34ze3qsp">
        <div className="flex items-start gap-4 mb-6" data-id="element-679" data-mp="b7wh1tkoygyd">
          <div className="w-12 h-12 rounded-full bg-peach/10 text-peach flex items-center justify-center flex-shrink-0" data-id="element-680" data-mp="b8oaoyuqa4m0">
            <PawPrint size={22} data-id="element-681" data-mp="21irb7b8s1ku3" />
          </div>
          <div data-id="element-682" data-mp="25l5u1vcg4kld">
            <h3 className="text-2xl font-black text-warmBrown mb-1" data-id="element-683" data-mp="25kvzdugghp9c">
              More Pawchi-Original Captions
            </h3>
            <p className="text-warmBrown/60 text-sm" data-id="element-684" data-mp="3q255jd1dkiqo">
              Original ideas built around the chase-and-transform moment — no
              Finch counterpart.
            </p>
          </div>
        </div>

        <div className="space-y-3" data-id="element-685" data-mp="3v3b3bp9w6w72">
          {["POV: me chasing my dog around the house because apparently turning him into a Tamagotchi is the only way I'll start taking care of myself.", "I turned my dog into a Tamagotchi and now he's somehow managing my life better than I am.", 'Was trying to make a digital version of my dog. Accidentally ended up in a healthier lifestyle.', "Me: can't stick to a habit tracker for more than 3 days.\nAlso me: chasing my dog so I can turn him into a Tamagotchi and finally get my life together."].map((caption, idx) => <div key={idx} className="bg-peach/10 rounded-2xl p-5 border border-peach/30" data-id="element-686" data-mp="2jgazxig97mls" data-mpi={idx}>
              <div className="flex items-center gap-2 mb-2" data-id="element-687" data-mp="2ltwpuabuhsc2">
                <span className="w-6 h-6 rounded-full bg-peach text-white flex items-center justify-center font-black text-xs flex-shrink-0" data-id="element-688" data-mp="2pvi9ceivx4v8">
                  {idx + 1}
                </span>
                <p className="text-xs font-bold uppercase tracking-wider text-peach" data-id="element-689" data-mp="2ztz3tlh181m1">
                  Pawchi
                </p>
              </div>
              <p className="text-warmBrown leading-relaxed font-medium whitespace-pre-line" data-id="element-690" data-mp="2281oty1v2eeu">
                "{caption}"
              </p>
            </div>)}
        </div>
      </section>

      {/* Bonus references */}
      <section className="bg-white rounded-3xl p-8 md:p-10 shadow-soft border border-warmBrown/5" data-id="element-691" data-mp="2c2tnz6b3d9bq">
        <div className="flex items-start gap-4 mb-6" data-id="element-692" data-mp="2gx67thghcmo0">
          <div className="w-12 h-12 rounded-full bg-lavender/10 text-lavender flex items-center justify-center flex-shrink-0" data-id="element-693" data-mp="1jf6aeb88niyl">
            <Film size={22} data-id="element-694" data-mp="1oczduwi5pyv6" />
          </div>
          <div data-id="element-695" data-mp="1gw2rvvy6h2qk">
            <h3 className="text-2xl font-black text-warmBrown mb-1" data-id="element-696" data-mp="1gui0ugb2o1xg">
              Bonus Reference Videos
            </h3>
            <p className="text-warmBrown/60 text-sm" data-id="element-697" data-mp="1bx822a1smdwy">
              Extra TikToks in the Finch / self-care UGC style worth studying.
            </p>
          </div>
        </div>

        <div className="space-y-3" data-id="element-698" data-mp="11xh6s65eruvt">
          {bonusReferences.map((ref, idx) => <a key={idx} href={ref.url} target="_blank" rel="noopener noreferrer" className="group flex items-center justify-between gap-4 p-4 bg-cream/60 hover:bg-peach/10 rounded-xl border border-warmBrown/5 hover:border-peach/30 transition-all" data-id="element-699" data-mp="xwx8gz93ml83" data-mpi={idx}>
              <div className="flex items-center gap-3 min-w-0" data-id="element-700" data-mp="j9lzn54axfbo">
                <div className="w-9 h-9 rounded-lg bg-white text-peach flex items-center justify-center flex-shrink-0 shadow-soft" data-id="element-701" data-mp="e8xznty3ho5b">
                  <Film size={16} data-id="element-702" data-mp="a7w901i8ukey" />
                </div>
                <div className="min-w-0" data-id="element-703" data-mp="3vqveya29r6dr">
                  <p className="font-medium text-warmBrown italic truncate" data-id="element-704" data-mp="3vq25v2fu84sg">
                    "{ref.caption}"
                  </p>
                  <p className="text-xs text-warmBrown/50 font-bold" data-id="element-705" data-mp="3mqoz4hj3lubf">
                    {ref.handle}
                  </p>
                </div>
              </div>
              <ArrowRight size={18} className="text-warmBrown/30 group-hover:text-peach group-hover:translate-x-1 transition-all flex-shrink-0" data-id="element-706" data-mp="3rq1sll4h5zmz" />
            </a>)}
        </div>
      </section>

      {/* Closing tip */}
      <Callout color="lavender" icon={<Lightbulb size={18} data-id="element-708" data-mp="9icavmcrghxh" />} title="How to use this swipe file" data-id="element-707" data-mp="9jdpu1wwdokh">
        Don't copy-paste verbatim. Pick a caption that fits your video, then{' '}
        <strong data-id="element-709" data-mp="1279ld3aqdafo">swap in specific details about your pet</strong> — breed, name,
        a unique quirk. The more specific, the higher the engagement.
      </Callout>
    </motion.article>;
}
function UgcBriefTopic() {
  const briefComponents = [{
    icon: <Anchor size={18} data-id="element-710" data-mp="1cdauzk2pa6ga" />,
    label: 'The hook',
    desc: 'Exact words and delivery style to open with'
  }, {
    icon: <Wand2 size={18} data-id="element-711" data-mp="1q2usaadiibi7" />,
    label: 'The transformation demo',
    desc: 'Exactly how to show pet upload → animated result'
  }, {
    icon: <Heart size={18} data-id="element-712" data-mp="xfigmv8w3o3o" />,
    label: 'The self-care loop',
    desc: 'How to connect habits to pet health in the demo'
  }, {
    icon: <Smile size={18} data-id="element-713" data-mp="teygdit0s4db" />,
    label: 'The emotional beat',
    desc: 'The moment of genuine delight or surprise to capture'
  }, {
    icon: <Link2 size={18} data-id="element-714" data-mp="17bbrma6yn9jc" />,
    label: 'The CTA',
    desc: '"Comment your pet and I\'ll show you" / link in bio / App Store'
  }];
  const hooks = ['"I accidentally found the cutest way to stay consistent with my habits."', '"My dog is now judging my self-care."', '"This app turned my pet into a little Tamagotchi."', '"I uploaded a photo of my pet and wasn\'t expecting this."'];
  const transformationSteps = ['Show the real pet first.', 'Capture a cute moment of the pet looking at the camera.', 'Open Pawchi and upload a photo of the pet.', 'Record the transformation process.', 'Reveal the generated Pawchi companion.', 'Spend a few seconds showing the resemblance between the real pet and the digital version.', 'Encourage creators to react genuinely to the result.'];
  const selfCareSteps = ['Briefly explain or demonstrate that completing habits affects the pet.', 'Show one or two habit completions such as drinking water, taking a walk, journaling, or checking in.', 'Return to the app and show the pet reacting positively.', 'The focus should be on the emotional connection, not on explaining features.'];
  const ctas = ['"If you have a pet, you need to try this."', '"Upload your pet and see what it becomes."', '"Link in bio if you want your own Pawchi."', '"Comment your pet and I\'ll show you what it would look like."'];
  const donts = ['Do not feature copyrighted or trademarked plushies.', 'Do not mention pricing.', 'Do not mention subscriptions.', 'Do not show paywalls.', 'Do not say "download now".', 'Do not make it sound like a traditional ad.', 'Do not over-explain features.', 'Do not use corporate language.'];
  return <motion.article initial={{
    opacity: 0,
    y: 20
  }} animate={{
    opacity: 1,
    y: 0
  }} transition={{
    duration: 0.4
  }} className="space-y-10" data-id="element-715" data-mp="3lzgyq2zic5q0">
      {/* Intro */}
      <header data-id="element-716" data-mp="382jzbd5bpfxi">
        <div className="inline-flex items-center gap-2 bg-sage/10 text-sage px-3 py-1.5 rounded-full text-xs font-bold uppercase tracking-wider mb-4" data-id="element-717" data-mp="3810kzs389eyd">
          <FileText size={14} data-id="element-718" data-mp="1wmn0mx7onhn3" />
          Creative Brief
        </div>
        <h2 className="text-3xl md:text-4xl font-black text-warmBrown mb-4" data-id="element-719" data-mp="1wlbz741pmlz5">
          UGC Brief Template
        </h2>
        <p className="text-warmBrown/80 text-lg leading-relaxed" data-id="element-720" data-mp="3l436zb763ois">
          The full creative brief for Pawchi videos. Use this as your shot list
          — every video should hit{' '}
          <strong className="text-warmBrown" data-id="element-721" data-mp="3badvm1zyqfxl">all five components</strong> and
          avoid the don'ts.
        </p>
      </header>

      {/* Goal */}
      <section className="bg-gradient-to-br from-peach to-coral rounded-3xl p-8 md:p-10 text-white" data-id="element-722" data-mp="31ej7ircyzsnf">
        <div className="inline-flex items-center gap-2 bg-white/20 backdrop-blur-sm px-3 py-1.5 rounded-full text-xs font-bold uppercase tracking-wider mb-4" data-id="element-723" data-mp="2xbmleqo81eeq">
          <Target size={14} data-id="element-724" data-mp="2nehwwk6wl6ur" />
          The Goal
        </div>
        <p className="text-xl md:text-2xl font-bold leading-snug" data-id="element-725" data-mp="2ng2t0e8v8xuq">
          Show how a real pet can be turned into a digital companion that
          motivates self-care.
        </p>
        <p className="text-white/90 leading-relaxed mt-4" data-id="element-726" data-mp="lo6eqwvbd9w9">
          The video should feel like a{' '}
          <strong className="text-white" data-id="element-727" data-mp="t5wbralabhot">personal discovery</strong>, not a
          sponsored promotion.
        </p>
      </section>

      {/* Brief components overview */}
      <section className="bg-white rounded-3xl p-8 md:p-10 shadow-soft border border-warmBrown/5" data-id="element-728" data-mp="12vxpp9jxbjq0">
        <h3 className="text-2xl font-black text-warmBrown mb-2" data-id="element-729" data-mp="17w3ln1x87sdw">
          Every brief includes 5 components
        </h3>
        <p className="text-warmBrown/60 text-sm mb-6" data-id="element-730" data-mp="a93g57ona4rb">
          Hit all five — in this order — for a complete video.
        </p>

        <div className="space-y-3" data-id="element-731" data-mp="f8zasgbgcju7">
          {briefComponents.map((item, index) => <div key={item.label} className="flex items-center gap-4 p-4 bg-cream/60 rounded-xl" data-id="element-732" data-mp="k4odutmokiv9" data-mpi={index}>
              <span className="w-8 h-8 rounded-full bg-peach text-white flex items-center justify-center font-black text-sm flex-shrink-0" data-id="element-733" data-mp="1vlem0ianzkri">
                {index + 1}
              </span>
              <div className="text-peach flex-shrink-0" data-id="element-734" data-mp="hzrpnqegqog">{item.icon}</div>
              <div className="flex-1 min-w-0" data-id="element-735" data-mp="g5aoki91ipn">
                <p className="font-bold text-warmBrown" data-id="element-736" data-mp="3roswf1kej7xq">{item.label}</p>
                <p className="text-sm text-warmBrown/60" data-id="element-737" data-mp="9io82p39n34i">{item.desc}</p>
              </div>
            </div>)}
        </div>
      </section>

      {/* Step 1: Hook */}
      <BriefStep number={1} title="Hook" subtitle="Open within the first 1–2 seconds." color="peach" icon={<Anchor size={22} data-id="element-739" data-mp="38y1kptcxz5g6" />} data-id="element-738" data-mp="5huno5p186gd">
        <p className="text-xs font-bold uppercase tracking-wider text-warmBrown/40 mb-3" data-id="element-740" data-mp="38z2xc29lw000">
          Choose one
        </p>
        <div className="space-y-2 mb-5" data-id="element-741" data-mp="3mratpswz9oy6">
          {hooks.map(hook => <div key={hook} className="bg-cream/60 rounded-xl px-4 py-3 text-warmBrown/80 italic border-l-4 border-peach/40" data-id="element-742" data-mp="3hxohg1uq7n2w">
              {hook}
            </div>)}
        </div>
        <Callout color="peach" icon={<Megaphone size={16} data-id="element-744" data-mp="2g2trzog9nft8" />} title="Delivery" data-id="element-743" data-mp="2q5ha5s141n16">
          Should feel natural, slightly surprised, and conversational.
        </Callout>
      </BriefStep>

      {/* Step 2: Transformation Demo */}
      <BriefStep number={2} title="Transformation Demo" subtitle="The reveal is the hero of the video." color="coral" icon={<Film size={22} data-id="element-746" data-mp="2b4jzjllxetbb" />} data-id="element-745" data-mp="265pfyhg4x0q5">
        <ol className="space-y-3" data-id="element-747" data-mp="2yu4hc16cfkj0">
          {transformationSteps.map((step, idx) => <li key={step} className="flex items-start gap-3" data-id="element-748" data-mp="33sxsvo22l1gj" data-mpi={idx}>
              <span className="mt-0.5 w-6 h-6 rounded-full bg-coral/15 text-coral flex items-center justify-center font-black text-xs flex-shrink-0" data-id="element-749" data-mp="33s6bbh5b5499">
                {idx + 1}
              </span>
              <span className="text-warmBrown/80 leading-relaxed" data-id="element-750" data-mp="2tt729xgmr6lq">{step}</span>
            </li>)}
        </ol>
      </BriefStep>

      {/* Step 3: Self-Care Loop */}
      <BriefStep number={3} title="Self-Care Loop" subtitle="Connect habits to pet wellbeing." color="lavender" icon={<Heart size={22} data-id="element-752" data-mp="1yokjd3k7yrju" />} data-id="element-751" data-mp="1igo0ia8vwpbd">
        <ol className="space-y-3 mb-5" data-id="element-753" data-mp="1tvrb45pjl130">
          {selfCareSteps.map((step, idx) => <li key={step} className="flex items-start gap-3" data-id="element-754" data-mp="1owepfoaeq020" data-mpi={idx}>
              <span className="mt-0.5 w-6 h-6 rounded-full bg-lavender/15 text-lavender flex items-center justify-center font-black text-xs flex-shrink-0" data-id="element-755" data-mp="1outsjs0me50z">
                {idx + 1}
              </span>
              <span className="text-warmBrown/80 leading-relaxed" data-id="element-756" data-mp="2hj99ik3baxey">{step}</span>
            </li>)}
        </ol>
      </BriefStep>

      {/* Step 4: Emotional Beat */}
      <BriefStep number={4} title="Emotional Beat" subtitle="The single most important moment in the video." color="sage" icon={<Smile size={22} data-id="element-758" data-mp="w8sefuyunt54" />} data-id="element-757" data-mp="27lusojdh86m4">
        <p className="text-warmBrown/80 leading-relaxed mb-4" data-id="element-759" data-mp="w9tz8r5o3u01">
          Capture the moment where the creator realizes:
        </p>
        <div className="bg-sage/10 border-l-4 border-sage/50 rounded-xl px-5 py-4 text-warmBrown/90 italic leading-relaxed mb-5" data-id="element-760" data-mp="rbimo8nzn5e4">
          "Wait… now I actually want to complete my habits because I don't want
          my pet to be sad."
        </div>
        <Callout color="sage" icon={<Sparkles size={16} data-id="element-762" data-mp="3hlfdm5rjy5om" />} title="What to capture" data-id="element-761" data-mp="3ctxd1itfy746">
          The creator should <strong data-id="element-763" data-mp="3hn8jhiucclvk">smile, laugh, or react naturally</strong>{' '}
          to the pet's response. This is the moment that converts viewers.
        </Callout>
      </BriefStep>

      {/* Step 5: CTA */}
      <BriefStep number={5} title="CTA" subtitle="End on an invitation, not a sales pitch." color="peach" icon={<Link2 size={22} data-id="element-765" data-mp="4duhucjimawq" />} data-id="element-764" data-mp="3qnyckes7vy5l">
        <p className="text-xs font-bold uppercase tracking-wider text-warmBrown/40 mb-3" data-id="element-766" data-mp="4ct420b47abb">
          Choose one
        </p>
        <div className="space-y-2" data-id="element-767" data-mp="2668y776ev7b1">
          {ctas.map(cta => <div key={cta} className="bg-cream/60 rounded-xl px-4 py-3 text-warmBrown/80 italic border-l-4 border-peach/40" data-id="element-768" data-mp="266in0rfpz8f5">
              {cta}
            </div>)}
        </div>
      </BriefStep>

      {/* Copyright rules */}
      <section className="bg-white rounded-3xl p-8 md:p-10 shadow-soft border border-coral/20" data-id="element-769" data-mp="284jovgu8rshv">
        <div className="flex items-start gap-4 mb-5" data-id="element-770" data-mp="233w1d5581tse">
          <div className="w-12 h-12 rounded-full bg-coral/10 text-coral flex items-center justify-center flex-shrink-0" data-id="element-771" data-mp="2h4f35uj3g3m4">
            <Ban size={22} data-id="element-772" data-mp="2d3mxfb9fkgul" />
          </div>
          <div data-id="element-773" data-mp="2d2laa8f543wi">
            <p className="text-xs font-bold uppercase tracking-wider text-coral mb-1" data-id="element-774" data-mp="2d10nx62zbr9q">
              Non-Negotiable
            </p>
            <h3 className="text-2xl font-black text-warmBrown" data-id="element-775" data-mp="2lun9629k9c4o">
              No Copyrighted or Trademarked Plushies
            </h3>
            <p className="text-warmBrown/60 text-sm mt-1" data-id="element-776" data-mp="30sxo1zx2guv0">
              Applies to the companion you feature and to anything visible on
              camera.
            </p>
          </div>
        </div>

        <p className="text-warmBrown/80 leading-relaxed mb-5" data-id="element-777" data-mp="3ffmpw8esjk4k">
          Licensed characters and branded plushies are protected trademarks. Do
          not turn them into a Pawchi, and do not feature them in your video —
          it exposes both you and Pawchi to takedowns and legal risk.
        </p>

        <p className="text-xs font-bold uppercase tracking-wider text-warmBrown/40 mb-2" data-id="element-778" data-mp="3ae72i9p551j0">
          Do not use
        </p>
        <div className="flex flex-wrap gap-2 mb-5" data-id="element-779" data-mp="2vpayqou4aao7">
          {['Disney characters', 'Jellycat', 'Squishmallows', 'Sanrio / Hello Kitty', 'Pokémon', 'Build-A-Bear licensed lines', 'Any branded or licensed character plush'].map(brand => <span key={brand} className="px-3 py-1.5 bg-coral/10 text-coral rounded-lg font-bold text-sm border border-coral/20" data-id="element-780" data-mp="2crzzv5cedj9a">
              {brand}
            </span>)}
        </div>

        <Callout color="sage" icon={<CheckCircle2 size={16} data-id="element-782" data-mp="2t7960s2g41oa" />} title="Use this instead" data-id="element-781" data-mp="2x8ktos1rectu">
          Your <strong data-id="element-783" data-mp="2o8fq6szoryky">real pet</strong>, a{' '}
          <strong data-id="element-784" data-mp="2o7efwqqhvg4a">generic, unbranded plushie or stuffed animal</strong>, or a
          non-licensed figure. Before you hit record, check the frame for
          branded plushies in the background too.
        </Callout>
      </section>

      {/* DO NOT section */}
      <section className="bg-warmBrown rounded-3xl p-8 md:p-10 text-cream" data-id="element-785" data-mp="29j9sj9ghygf6">
        <div className="flex items-start gap-4 mb-6" data-id="element-786" data-mp="25i7q6jra9o8z">
          <div className="w-12 h-12 rounded-full bg-coral/20 text-coral flex items-center justify-center flex-shrink-0" data-id="element-787" data-mp="25iznq04fxw1w">
            <Ban size={22} data-id="element-788" data-mp="20ky1557t3elo" />
          </div>
          <div data-id="element-789" data-mp="1vkjt3n67g4nn">
            <h3 className="text-2xl font-black mb-1" data-id="element-790" data-mp="1viyyxynsynqb">DO NOT</h3>
            <p className="text-cream/60 text-sm" data-id="element-791" data-mp="1qkxfhcmgsmeb">
              These will sink the video. Avoid every one.
            </p>
          </div>
        </div>

        <ul className="space-y-3" data-id="element-792" data-mp="1ggh34t871nf9">
          {donts.map(item => <li key={item} className="flex items-start gap-3" data-id="element-793" data-mp="1lfaiysaydqil">
              <XCircle size={18} className="text-coral mt-0.5 flex-shrink-0" data-id="element-794" data-mp="1lhwlgdizlfty" />
              <span className="text-cream/85 leading-relaxed" data-id="element-795" data-mp="1qfy9zdz6m7ct">{item}</span>
            </li>)}
        </ul>
      </section>

      {/* Closing mantra */}
      <section className="bg-white rounded-3xl p-8 md:p-10 shadow-soft border border-warmBrown/5 text-center" data-id="element-796" data-mp="xraiv1rr4nrc">
        <p className="text-xs font-bold uppercase tracking-wider text-warmBrown/40 mb-4" data-id="element-797" data-mp="12qdlygo68jwo">
          Think
        </p>
        <p className="text-2xl md:text-3xl font-black text-warmBrown leading-tight" data-id="element-798" data-mp="17ndsstsuhqou">
          Personal discovery. Emotional reaction. Cute pet moment. Self-care
          motivation.
        </p>
      </section>
    </motion.article>;
}
interface BriefStepProps {
  number: number;
  title: string;
  subtitle: string;
  color: 'peach' | 'coral' | 'lavender' | 'sage';
  icon: React.ReactNode;
  children: React.ReactNode;
}
function BriefStep({
  number,
  title,
  subtitle,
  color,
  icon,
  children
}: BriefStepProps) {
  const colorMap = {
    peach: {
      bg: 'bg-peach/10',
      text: 'text-peach',
      solid: 'bg-peach'
    },
    coral: {
      bg: 'bg-coral/10',
      text: 'text-coral',
      solid: 'bg-coral'
    },
    lavender: {
      bg: 'bg-lavender/10',
      text: 'text-lavender',
      solid: 'bg-lavender'
    },
    sage: {
      bg: 'bg-sage/10',
      text: 'text-sage',
      solid: 'bg-sage'
    }
  };
  const c = colorMap[color];
  return <section className="bg-white rounded-3xl p-8 md:p-10 shadow-soft border border-warmBrown/5" data-id="element-799" data-mp="2vqgq0dtusdfb">
      <div className="flex items-start gap-4 mb-6" data-id="element-800" data-mp="30pjpzjuz7tgf">
        <div className={`w-14 h-14 rounded-2xl ${c.solid} text-white flex items-center justify-center flex-shrink-0 font-black text-xl`} data-id="element-801" data-mp="2moph7040nqh8">
          {number}
        </div>
        <div className="flex-1 min-w-0" data-id="element-802" data-mp="2qs5dtwg35qtx">
          <div className="flex items-center gap-2 mb-1" data-id="element-803" data-mp="2818pzyjafzpu">
            <span className={c.text} data-id="element-804" data-mp="283v5qlgc1lj5">{icon}</span>
            <p className={`text-xs font-bold uppercase tracking-wider ${c.text}`} data-id="element-805" data-mp="233z1cl3q3s32">
              Step {number}
            </p>
          </div>
          <h3 className="text-2xl font-black text-warmBrown mb-1" data-id="element-806" data-mp="2c3vje3vlxsp5">{title}</h3>
          <p className="text-warmBrown/60 text-sm" data-id="element-807" data-mp="2c5yiddeqmw60">{subtitle}</p>
        </div>
      </div>
      <div data-id="element-808" data-mp="2qyrxuyu0fcao">{children}</div>
    </section>;
}
interface EngagementBucketProps {
  percent: number;
  label: string;
  color: 'peach' | 'coral' | 'lavender' | 'sage';
  items: string[];
  goal: string;
}
function EngagementBucket({
  percent,
  label,
  color,
  items,
  goal
}: EngagementBucketProps) {
  const colorMap = {
    peach: {
      bg: 'bg-peach/10',
      text: 'text-peach',
      solid: 'bg-peach',
      dot: 'bg-peach'
    },
    coral: {
      bg: 'bg-coral/10',
      text: 'text-coral',
      solid: 'bg-coral',
      dot: 'bg-coral'
    },
    lavender: {
      bg: 'bg-lavender/10',
      text: 'text-lavender',
      solid: 'bg-lavender',
      dot: 'bg-lavender'
    },
    sage: {
      bg: 'bg-sage/10',
      text: 'text-sage',
      solid: 'bg-sage',
      dot: 'bg-sage'
    }
  };
  const c = colorMap[color];
  return <div className="bg-cream/60 rounded-2xl p-5 md:p-6" data-id="element-809" data-mp="2g6jfbv9ciz34">
      <div className="flex items-center gap-4 mb-4" data-id="element-810" data-mp="2g84ejy6lv67b">
        <div className={`${c.solid} text-white font-black text-lg md:text-xl rounded-2xl px-4 py-2 flex-shrink-0`} data-id="element-811" data-mp="2l4kzykmf76gp">
          {percent}%
        </div>
        <h4 className="font-black text-warmBrown text-lg md:text-xl" data-id="element-812" data-mp="2u5j6pao8ts2z">
          {label}
        </h4>
      </div>

      {/* Visual percentage bar */}
      <div className="h-1.5 bg-warmBrown/5 rounded-full overflow-hidden mb-5" data-id="element-813" data-mp="2z4clr7j6hr59">
        <div className={`h-full ${c.solid} rounded-full`} style={{
        width: `${percent}%`
      }} data-id="element-814" data-mp="ztbggamv9zdj" />
      </div>

      <ul className="grid sm:grid-cols-2 gap-x-4 gap-y-2 mb-5" data-id="element-815" data-mp="x7ln9mumcnj2">
        {items.map(item => <li key={item} className="flex items-center gap-2 text-warmBrown/80 text-sm" data-id="element-816" data-mp="sgvctv7c5uhi">
            <span className={`w-1.5 h-1.5 rounded-full ${c.dot} flex-shrink-0`} data-id="element-817" data-mp="nh0q83ulfr29"></span>
            {item}
          </li>)}
      </ul>

      <div className={`${c.bg} rounded-xl px-4 py-3`} data-id="element-818" data-mp="1g6fzao2p79vj">
        <p className="text-xs font-bold uppercase tracking-wider text-warmBrown/40 mb-1" data-id="element-819" data-mp="1g54tyjtltu2b">
          Goal
        </p>
        <p className={`text-sm font-bold ${c.text}`} data-id="element-820" data-mp="1b861e5pl9v68">{goal}</p>
      </div>
    </div>;
}
interface PhaseCardProps {
  phase: string;
  title: string;
  color: 'peach' | 'coral' | 'lavender' | 'sage';
  icon: React.ReactNode;
  children: React.ReactNode;
}
function PhaseCard({
  phase,
  title,
  color,
  icon,
  children
}: PhaseCardProps) {
  const colorMap = {
    peach: {
      bg: 'bg-peach/10',
      text: 'text-peach'
    },
    coral: {
      bg: 'bg-coral/10',
      text: 'text-coral'
    },
    lavender: {
      bg: 'bg-lavender/10',
      text: 'text-lavender'
    },
    sage: {
      bg: 'bg-sage/10',
      text: 'text-sage'
    }
  };
  const c = colorMap[color];
  return <section className="bg-white rounded-3xl p-8 md:p-10 shadow-soft border border-warmBrown/5" data-id="element-821" data-mp="14rmhsp2dtldt">
      <div className="flex items-start gap-4 mb-6" data-id="element-822" data-mp="19pnzp6o2nenp">
        <div className={`w-12 h-12 rounded-full ${c.bg} ${c.text} flex items-center justify-center flex-shrink-0`} data-id="element-823" data-mp="1xeytu5ax2asv">
          {icon}
        </div>
        <div data-id="element-824" data-mp="22bpj9j8m2iqy">
          <p className={`text-xs font-bold uppercase tracking-wider ${c.text} mb-1`} data-id="element-825" data-mp="22bfrpr7x43j5">
            {phase}
          </p>
          <h3 className="text-2xl font-black text-warmBrown" data-id="element-826" data-mp="1sekudbnds96g">{title}</h3>
        </div>
      </div>
      <div className="space-y-4" data-id="element-827" data-mp="cylz30yv47nm">{children}</div>
    </section>;
}
interface RuleProps {
  icon: React.ReactNode;
  children: React.ReactNode;
  negative?: boolean;
}
function Rule({
  icon,
  children,
  negative
}: RuleProps) {
  return <div className="flex items-start gap-3" data-id="element-828" data-mp="9f3fp9826l21">
      <div className={`mt-0.5 flex-shrink-0 ${negative ? 'text-coral' : 'text-peach'}`} data-id="element-829" data-mp="4iczmlw97pgm">
        {icon}
      </div>
      <p className="text-warmBrown/80 leading-relaxed" data-id="element-830" data-mp="jdsz56flsdke">{children}</p>
    </div>;
}
interface CalloutProps {
  color: 'peach' | 'sage' | 'lavender' | 'coral';
  icon: React.ReactNode;
  title: string;
  children: React.ReactNode;
}
function Callout({
  color,
  icon,
  title,
  children
}: CalloutProps) {
  const colorMap = {
    peach: {
      bg: 'bg-peach/10',
      border: 'border-peach/20',
      text: 'text-peach'
    },
    sage: {
      bg: 'bg-sage/10',
      border: 'border-sage/20',
      text: 'text-sage'
    },
    lavender: {
      bg: 'bg-lavender/10',
      border: 'border-lavender/20',
      text: 'text-lavender'
    },
    coral: {
      bg: 'bg-coral/10',
      border: 'border-coral/20',
      text: 'text-coral'
    }
  };
  const c = colorMap[color];
  return <div className={`${c.bg} ${c.border} border rounded-2xl p-5 mt-6`} data-id="element-831" data-mp="3ov73fh7oqrb5">
      <div className="flex items-center gap-2 mb-2" data-id="element-832" data-mp="3svr0kks9duxa">
        <span className={c.text} data-id="element-833" data-mp="3sufycpegov8a">{icon}</span>
        <p className={`font-bold ${c.text}`} data-id="element-834" data-mp="1hla4hz6z5jl">{title}</p>
      </div>
      <p className="text-warmBrown/80 leading-relaxed text-sm" data-id="element-835" data-mp="1jehy0ljjvt6">{children}</p>
    </div>;
}